import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.qa.operator');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-qa-operator',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.qa.operator/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
  background: #f3f5f6;
  color: #18232c;
}

* {
  box-sizing: border-box;
}

.qa-operator-page {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.qa-chat-shell {
  display: grid;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  grid-template-columns: 260px minmax(0, 1fr);
  background: #fff;
}

.qa-operator-alert {
  position: absolute;
  z-index: 100;
  top: 16px;
  right: 38px;
  display: flex;
  width: max-content;
  max-width: min(520px, 100% - 76px);
  align-items: center;
  gap: 9px;
  padding: 11px 13px;
  border: 1px solid #e7b9b9;
  border-radius: 6px;
  background: #fff3f2;
  box-shadow: 0 8px 22px rgba(94, 36, 36, 0.12);
  color: #9a2c2c;
  font-size: 13px;
  line-height: 1.45;
}

.qa-operator-alert span {
  min-width: 0;
  flex: 1;
  overflow-wrap: anywhere;
}

.qa-operator-alert button {
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.qa-operator-alert button:hover {
  background: rgba(154, 44, 44, 0.08);
}

.qa-chat-sidebar {
  display: grid;
  min-width: 0;
  min-height: 0;
  padding: 16px 12px 14px;
  grid-template-rows: auto auto auto auto minmax(0, 1fr) auto;
  border-right: 1px solid #e1e6e8;
  background: #f7f8f8;
}

.qa-chat-sidebar__header,
.qa-chat-sidebar__header > div,
.qa-history-heading,
.qa-chat-sidebar__footer > div:first-child,
.qa-sidebar-usage,
.qa-chat-header,
.qa-chat-header__actions,
.qa-chat-context,
.qa-context-trigger,
.qa-context-option,
.qa-exchange__answer-content > header,
.qa-approval-drawer__header,
.qa-drawer-proposal > header,
.qa-drawer-proposal > header > div,
.qa-drawer-proposal footer,
.qa-composer__footer {
  display: flex;
  align-items: center;
}

.qa-chat-sidebar__header {
  justify-content: space-between;
  gap: 8px;
  min-height: 42px;
  padding: 0 3px;
}

.qa-chat-sidebar__header > div {
  min-width: 0;
  gap: 9px;
}

.qa-chat-sidebar__header > div > div {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.qa-chat-sidebar__header strong {
  overflow: hidden;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-chat-sidebar__header small {
  color: #7a878e;
  font-size: 12px;
}

.qa-assistant-logo,
.qa-assistant-mark,
.qa-empty-mark {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  background: #e5f2ee;
  color: #236e5b;
}

.qa-assistant-logo {
  width: 32px;
  height: 32px;
  border-radius: 7px;
}

.qa-assistant-mark {
  width: 27px;
  height: 27px;
  border-radius: 6px;
}

.qa-empty-mark {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  font-size: 18px;
}

.qa-icon-button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #d1d9dd;
  background: #fff;
  color: #4b5b65;
}

.qa-icon-button:disabled {
  opacity: 0.5;
}

.qa-new-chat {
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  gap: 9px;
  margin-top: 16px;
  padding: 0 12px;
  border: 1px solid #cbd6da;
  background: #fff;
  color: #263740;
}

.qa-new-chat:hover {
  border-color: #2b7965;
  background: #f2f8f6;
  color: #1d6754;
}

.qa-new-chat:disabled {
  opacity: 0.55;
}

.qa-history-search {
  border: 1px solid #d5dde0;
  background: #fdfefe;
  color: #7a888f;
  cursor: text;
}

.qa-history-search:focus-within {
  border-color: #6a9f91;
}

.qa-history-search i {
  flex: 0 0 auto;
  color: #718189;
  font-size: 12px;
}

.qa-history-search input,
.qa-history-search input[type=search] {
  width: 100%;
  height: 100%;
  min-width: 0;
  padding: 0;
  box-shadow: none !important;
  color: #2b3b43;
  appearance: none;
  font: inherit;
  font-size: 12px;
}

.qa-history-search input::placeholder {
  color: #8b979d;
  opacity: 1;
}

.qa-history-search input::-webkit-search-cancel-button {
  appearance: none;
}

.qa-history-heading {
  justify-content: space-between;
  padding: 19px 5px 8px;
  color: #718087;
  font-size: 12px;
  font-weight: 700;
}

.qa-history-heading small {
  min-width: 20px;
  padding: 2px 5px;
  border-radius: 4px;
  background: #e8edef;
  text-align: center;
  font-size: 12px;
}

.qa-chat-history {
  min-height: 0;
  display: flex;
  overflow-y: auto;
  flex-direction: column;
}

@media (min-width: 721px) {
  /* Keep each vertical history group intact; the nav owns scrolling. */
  .qa-chat-history > .qa-history-project,
  .qa-chat-history > .qa-history-direct,
  .qa-chat-history > .qa-history-section-header {
    flex: 0 0 auto;
  }
}
.qa-history-section-header {
  min-height: 38px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 7px;
  padding: 8px 6px 6px;
  border: 0;
  border-bottom: 1px solid #e3e8e9;
  color: #6e7d84;
  background: #f7f8f8;
  cursor: pointer;
  text-align: left;
}

.qa-history-section-header--projects {
  order: 1;
}

.qa-chat-history > .qa-history-project {
  order: 2;
}

.qa-chat-history > .qa-history-direct {
  order: 3;
}

.qa-history-section-header--direct {
  width: 100%;
  min-height: 36px;
  margin: 0;
  padding: 0 9px;
  border: 0;
  background: #fff;
}

.qa-chat-history > .qa-history-empty {
  order: 4;
}

.qa-history-section-header > span {
  overflow: hidden;
  letter-spacing: 0.01em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-history-section-header > em {
  order: 3;
  min-width: 20px;
  height: 20px;
  display: inline-grid;
  padding: 0 6px;
  place-items: center;
  color: #74828a;
  background: #e8edef;
  font-style: normal;
}

.qa-history-section-header > i {
  order: 2;
  color: #839096;
  font-size: 12px;
  transition: transform 0.16s ease;
}

.qa-history-section-header.is-collapsed > i {
  transform: rotate(-90deg);
}

.qa-history-section-header--direct.is-collapsed {
  border: 0;
}

.qa-history-section-header:hover {
  color: #315f54;
  background: #eef3f1;
}

.qa-history-section-header:focus-visible {
  outline: 2px solid rgba(42, 126, 104, 0.2);
  outline-offset: -2px;
}

.qa-history-direct {
  overflow: hidden;
  margin: 13px 2px 4px;
  border: 1px solid #dce4e2;
  border-radius: 7px;
  background: #fff;
}

.qa-history-direct__body {
  border-top: 1px solid #e7ecea;
  background: #fff;
}

.qa-history-direct__body[hidden] {
  display: none !important;
}

.qa-history-direct .qa-history-entry {
  margin: 0;
  padding: 2px 3px;
  border: 0;
  border-radius: 0;
  background: #fff;
}

.qa-history-direct .qa-history-entry + .qa-history-entry {
  margin-top: 0;
  border-top: 1px solid #edf0ef;
}

.qa-history-direct .qa-history-entry:last-child {
  padding-bottom: 4px;
}

.qa-chat-history > [hidden] {
  display: none !important;
}

.qa-history-entry + .qa-history-entry {
  margin-top: 2px;
}

.qa-history-row {
  position: relative;
  display: flex;
  min-width: 0;
  align-items: center;
}

.qa-history-item {
  display: grid;
  width: 100%;
  min-width: 0;
  flex: 1;
  min-height: 53px;
  grid-template-columns: 18px minmax(0, 1fr);
  align-items: start;
  gap: 8px;
  padding: 9px 68px 9px 9px;
  border: 0;
  background: transparent;
  color: #53626b;
  text-align: left;
}

.qa-history-item > i {
  margin-top: 2px;
  font-size: 12px;
}

.qa-history-item > span {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.qa-history-item strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-history-item small {
  color: #8b979d;
}

.qa-history-item:hover {
  background: #edf1f2;
}

.qa-history-item.is-active {
  background: #e4efeb;
  color: #1e6654;
}

.qa-history-direct .qa-history-item {
  min-height: 48px;
  padding-block: 7px;
}

.qa-history-delete,
.qa-history-edit {
  position: absolute;
  z-index: 1;
  top: 50%;
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: #859198;
  cursor: pointer;
  opacity: 0;
  transform: translateY(-50%);
  transition: background-color 0.12s ease, color 0.12s ease, opacity 0.12s ease;
}

.qa-history-edit {
  right: 33px;
}

.qa-history-delete {
  right: 4px;
}

.qa-history-delete i,
.qa-history-edit i {
  width: 13px;
  text-align: center;
}

.qa-history-delete:focus-visible,
.qa-history-edit:focus-visible {
  opacity: 1;
}

.qa-history-row:hover .qa-history-delete,
.qa-history-row:hover .qa-history-edit {
  opacity: 1;
}

.qa-history-delete:hover {
  background: #fbeceb;
  color: #b5423c;
}

.qa-history-edit:hover {
  background: #e4efeb;
  color: #1f6b58;
}

.qa-history-delete:focus-visible {
  outline: 2px solid rgba(181, 66, 60, 0.2);
  outline-offset: 1px;
}

.qa-history-delete:disabled,
.qa-history-edit:disabled {
  cursor: not-allowed;
}

.qa-history-rename {
  display: none;
  min-width: 0;
  flex: 1;
  grid-template-columns: minmax(0, 1fr) 32px 32px;
  align-items: center;
  gap: 4px;
  min-height: 48px;
  padding: 5px;
  border: 1px solid #ccd8d4;
  border-radius: 7px;
  background: #fff;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}

.qa-history-entry.is-renaming .qa-history-item,
.qa-history-entry.is-renaming .qa-history-edit,
.qa-history-entry.is-renaming .qa-history-delete {
  display: none;
}

.qa-history-entry.is-renaming .qa-history-rename {
  display: grid;
}

.qa-history-rename:focus-within {
  border-color: #4b8b7a;
  box-shadow: 0 0 0 2px rgba(42, 126, 104, 0.1);
}

.qa-chat-sidebar .qa-history-rename input,
.qa-chat-sidebar .qa-history-rename input:focus,
.qa-chat-sidebar .qa-history-rename input:focus-visible {
  min-width: 0;
  height: 34px;
  padding: 0 8px;
  border: 0 !important;
  border-radius: 4px;
  outline: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  color: #26363e;
  font: inherit;
  font-size: 12px;
}

.qa-history-rename button {
  position: relative;
  z-index: 2;
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border: 0;
  background: #edf2f3;
  color: #586a73;
  cursor: pointer;
  pointer-events: auto;
  touch-action: manipulation;
}

.qa-history-rename button:first-of-type {
  background: #216f5c;
  color: #fff;
}

.qa-history-rename button:first-of-type:hover {
  background: #195f4e;
}

.qa-history-rename button:last-of-type:hover {
  background: #e3e9eb;
  color: #354851;
}

.qa-history-rename button:focus-visible {
  outline: 2px solid #4b8b7a;
  outline-offset: 1px;
}

.qa-history-confirm {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 4px;
  margin: 2px 4px 6px;
  padding: 6px 7px;
  border-top: 1px solid #e1e6e8;
  color: #65747c;
  font-size: 12px;
}

.qa-history-confirm button {
  display: inline-flex;
  min-height: 25px;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0 7px;
  border: 1px solid #d3dade;
  background: #fff;
  color: #53636c;
}

.qa-history-confirm button.is-danger {
  border-color: #e5bbb8;
  background: #fff5f4;
  color: #aa3934;
}

.qa-history-project {
  overflow: hidden;
  margin: 4px 2px;
  border: 1px solid #dce4e2;
  border-radius: 7px;
  background: #fff;
}

.qa-history-project__header {
  width: 100%;
  min-height: 44px;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) 18px;
  align-items: center;
  gap: 8px;
  padding: 6px 9px;
  border: 0;
  background: #fff;
  color: #34464a;
  cursor: pointer;
  text-align: left;
}

.qa-history-project__header:hover {
  background: #f1f6f4;
}

.qa-history-project:not(.is-collapsed) .qa-history-project__header {
  background: #eaf3ef;
}

.qa-history-project__header:focus-visible {
  outline: 2px solid rgba(42, 126, 104, 0.22);
  outline-offset: -2px;
}

.qa-history-project__icon {
  width: 26px;
  height: 26px;
  display: inline-grid;
  place-items: center;
  border-radius: 6px;
  color: #28745f;
  background: #e4f0ec;
  font-size: 12px;
}

.qa-history-project__label {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.qa-history-project__label strong {
  overflow: hidden;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-history-project__label small {
  color: #819096;
  font-size: 12px;
  font-weight: 600;
}

.qa-history-project__chevron {
  color: #728188;
  font-size: 12px;
  transition: transform 0.16s ease;
}

.qa-history-project.is-collapsed .qa-history-project__chevron {
  transform: rotate(-90deg);
}

.qa-history-project__body {
  padding: 2px 3px 4px;
  border-top: 1px solid #e1e7e5;
  background: #fbfcfb;
}

.qa-history-project__body .qa-history-entry + .qa-history-entry {
  margin-top: 1px;
}

.qa-history-project__body .qa-history-item {
  min-height: 46px;
}

.qa-history-more {
  width: calc(100% - 10px);
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin: 4px 5px 1px;
  padding: 0 10px;
  border: 1px solid #dce3e1;
  color: #52656b;
  background: #f8faf9;
  cursor: pointer;
}

.qa-history-more small {
  color: #8a969a;
}

.qa-history-more i {
  color: #718087;
  font-size: 12px;
}

.qa-history-more:hover {
  border-color: #b8ccc6;
  color: #1f6b58;
  background: #edf5f2;
}

.qa-history-empty {
  display: grid;
  justify-items: center;
  gap: 8px;
  padding: 36px 8px;
  color: #89959b;
  font-size: 12px;
}

.qa-chat-sidebar__footer {
  display: grid;
  gap: 8px;
  padding: 13px 5px 0;
  border-top: 1px solid #e0e5e7;
}

.qa-chat-sidebar__footer > div:first-child {
  justify-content: space-between;
  gap: 8px;
}

.qa-chat-sidebar__footer > div:first-child span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 700;
}

.qa-chat-sidebar__footer > div:first-child i {
  margin-right: 5px;
  color: #2b7965;
}

.qa-codex-login {
  display: inline-flex;
  height: 25px;
  flex: 0 0 auto;
  align-items: center;
  gap: 5px;
  padding: 0 8px;
  border: 1px solid #ccd8d5;
  background: #fff;
  color: #4f6269;
  cursor: pointer;
}

.qa-chat-sidebar__footer > div:first-child .qa-codex-login i {
  margin: 0;
  color: inherit;
}

.qa-codex-login:hover {
  border-color: #8db7aa;
  background: #edf6f3;
  color: #216f5c;
}

.qa-codex-login.is-connected {
  border-color: #a8cfc3;
  background: #e9f5f1;
  color: #216f5c;
}

.qa-codex-login:disabled {
  cursor: wait;
  opacity: 0.65;
}

.qa-sidebar-usage {
  justify-content: space-between;
  gap: 8px;
  color: #7b888f;
  font-size: 12px;
}

.qa-sidebar-usage strong {
  color: #4d5c65;
  font-size: 12px;
}

.qa-runtime-track {
  height: 3px;
  overflow: hidden;
  border-radius: 2px;
  background: #e1e7e9;
}

.qa-runtime-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #2c806b;
}

.qa-codex-backdrop {
  position: fixed;
  z-index: 220;
  inset: 0;
  border: 0;
  background: rgba(20, 30, 35, 0.4);
  cursor: default;
}

.qa-codex-dialog {
  position: fixed;
  z-index: 221;
  top: 50%;
  left: 50%;
  display: grid;
  width: min(720px, 100% - 32px);
  justify-items: center;
  gap: 14px;
  padding: 30px 32px 24px;
  border: 1px solid #dce4e2;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 24px 64px rgba(28, 43, 48, 0.22);
  transform: translate(-50%, -50%);
  text-align: center;
}

.qa-codex-dialog__close {
  position: absolute;
  top: 10px;
  right: 10px;
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: #718087;
  cursor: pointer;
}

.qa-codex-dialog__close:hover {
  background: #f0f3f3;
}

.qa-codex-dialog__mark {
  display: inline-flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #eef2f3;
  color: #64747b;
  font-size: 18px;
}

.qa-codex-dialog__mark.is-connected {
  background: #e5f3ef;
  color: #23745f;
}

.qa-codex-dialog h2 {
  margin: 0;
  font-size: 19px;
}

.qa-codex-dialog p {
  margin: 0;
  color: #596a72;
  font-size: 12px;
  line-height: 1.6;
}

.qa-codex-heading {
  display: grid;
  width: 100%;
  justify-items: center;
  gap: 6px;
}

.qa-codex-heading > div {
  display: flex;
  align-items: center;
  gap: 9px;
}

.qa-codex-device-badge {
  padding: 4px 8px;
  border-radius: 5px;
  background: #e6f5ef;
  color: #187059;
  font-size: 12px;
  font-weight: 700;
}

.qa-codex-runtime-note {
  display: grid;
  width: 100%;
  gap: 5px;
  padding: 13px 15px;
  border-radius: 7px;
  background: #f1f3ff;
  color: #343bb4;
  text-align: left;
}

.qa-codex-runtime-note strong {
  font-size: 12px;
}

.qa-codex-runtime-note span {
  font-size: 12px;
  line-height: 1.55;
}

.qa-codex-loading {
  display: flex;
  width: 100%;
  min-height: 104px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  border-radius: 7px;
  background: #f6f8f9;
  color: #607178;
  font-size: 12px;
}

.qa-codex-device {
  display: grid;
  width: 100%;
  gap: 16px;
  padding: 18px 20px 15px;
  border-radius: 7px;
  background: #f7f8fa;
  text-align: left;
}

.qa-codex-device__link {
  display: inline-flex;
  width: max-content;
  max-width: 100%;
  align-items: center;
  gap: 7px;
  color: #17233a;
  font-size: 14px;
  font-weight: 700;
  text-decoration: underline;
  overflow-wrap: anywhere;
}

.qa-codex-device__link i {
  font-size: 12px;
}

.qa-codex-device__code {
  display: flex;
  align-items: center;
  gap: 10px;
}

.qa-codex-device__code > span {
  color: #77868e;
  font-size: 12px;
}

.qa-codex-device__code strong {
  padding: 8px 11px;
  border-radius: 6px;
  background: #fff;
  color: #111a2c;
  font-size: 17px;
  letter-spacing: 0.04em;
}

.qa-codex-device__code button {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d5dde2;
  background: #fff;
  color: #65757d;
  cursor: pointer;
}

.qa-codex-device__code time {
  color: #8796a6;
  font-size: 12px;
}

.qa-codex-device p.qa-codex-device__warning {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  color: #7c6751;
  font-size: 12px;
}

.qa-codex-device__warning i {
  margin-top: 3px;
  color: #9c7a53;
}

.qa-codex-connected {
  display: grid;
  width: 100%;
  gap: 13px;
  padding: 17px;
  border-radius: 7px;
  background: #edf7f3;
  color: #216f5c;
  text-align: left;
}

.qa-codex-connected__status {
  display: flex;
  align-items: center;
  gap: 12px;
}

.qa-codex-connected__status > i {
  font-size: 22px;
}

.qa-codex-connected__status > div {
  display: grid;
  gap: 3px;
}

.qa-codex-connected strong {
  font-size: 12px;
}

.qa-codex-connected span {
  color: #54736a;
  font-size: 12px;
}

.qa-codex-account {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 12px;
  border-top: 1px solid #d7e9e2;
}

.qa-codex-account > i {
  display: inline-flex;
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #dcefe8;
  color: #27725f;
  font-size: 12px;
}

.qa-codex-account > div {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.qa-codex-account small {
  color: #6a847c;
  font-size: 12px;
  font-weight: 700;
}

.qa-codex-account strong,
.qa-codex-account span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-codex-account strong {
  color: #235e4f;
  font-size: 12px;
}

.qa-codex-account span {
  font-size: 12px;
}

.qa-codex-state-message {
  width: 100%;
  padding: 13px 15px;
  border-radius: 7px;
  background: #f6f8f9;
  text-align: left;
}

.qa-codex-dialog footer {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
  padding-top: 14px;
  border-top: 1px solid #e5e9ea;
}

.qa-codex-dialog footer button,
.qa-codex-dialog footer a {
  display: inline-flex;
  height: 36px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
}

.qa-codex-disconnect,
.qa-codex-restart {
  border: 1px solid #d9e0e2;
  background: #fff;
  color: #67777e;
}

.qa-codex-open-link {
  border: 1px solid #bfc8ff;
  background: #f0f2ff;
  color: #4348cc;
}

.qa-codex-dialog__confirm {
  border: 1px solid #216f5c;
  background: #216f5c;
  color: #fff;
}

.qa-codex-dialog footer button:disabled {
  cursor: wait;
  opacity: 0.6;
}

.qa-chat-main {
  --qa-chat-header-height: 78px;
  position: relative;
  display: grid;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  grid-template-rows: minmax(0, 1fr) auto auto;
  background: #fff;
}

.qa-chat-header {
  z-index: 20;
  border-bottom: 1px solid #e2e7e9;
  background: #fff;
}

.qa-chat-title {
  min-width: 0;
}

.qa-chat-title h1 {
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-chat-title p {
  margin: 4px 0 0;
  color: #7a878e;
  font-size: 12px;
}

.qa-chat-header__actions {
  min-width: 0;
  flex: 0 1 820px;
  justify-content: flex-end;
  gap: 8px;
}

.qa-chat-context {
  min-width: 0;
  flex: 1 1 680px;
  justify-content: flex-end;
  gap: 8px;
}

.qa-context-picker {
  position: relative;
  width: min(210px, 33.333%);
  height: 40px;
  flex: 0 1 210px;
}

.qa-context-trigger {
  width: 100%;
  height: 100%;
  gap: 9px;
  padding: 0 11px;
  border: 1px solid #d2dade;
  background: #fff;
  color: #6e7d85;
  text-align: left;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.qa-context-trigger:hover {
  border-color: #aebdc2;
}

.qa-context-trigger:focus-visible,
.qa-context-picker.is-open .qa-context-trigger {
  border-color: #438b78;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(42, 126, 104, 0.1);
}

.qa-context-trigger > i:first-child {
  width: 17px;
  flex: 0 0 17px;
  color: #72828a;
  text-align: center;
}

.qa-context-trigger > span {
  overflow: hidden;
  min-width: 0;
  flex: 1;
  color: #35454e;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-context-chevron {
  flex: 0 0 auto;
  color: #8a979d;
  font-size: 12px;
  pointer-events: none;
  transition: transform 0.15s ease;
}

.qa-context-picker.is-open .qa-context-chevron {
  transform: rotate(180deg);
}

.qa-context-menu {
  position: absolute;
  z-index: 40;
  top: calc(100% + 7px);
  left: 0;
  width: max(100%, 220px);
  max-height: min(360px, 100vh - 150px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 7px;
  border: 1px solid #d5dcdf;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 14px 34px rgba(31, 43, 49, 0.18), 0 3px 10px rgba(31, 43, 49, 0.08);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-5px);
  transition: opacity 0.14s ease, transform 0.14s ease, visibility 0s linear 0.14s;
}

.qa-context-menu[aria-hidden=true] {
  display: none;
  box-shadow: none;
}

.qa-context-picker.is-open .qa-context-menu {
  display: block;
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  transition-delay: 0s;
}

.qa-context-picker:last-child .qa-context-menu {
  right: 0;
  left: auto;
}

.qa-context-option {
  width: 100%;
  min-height: 38px;
  gap: 9px;
  padding: 7px 9px;
  border: 0;
  background: transparent;
  color: #25343c;
  text-align: left;
}

.qa-context-option:hover,
.qa-context-option:focus-visible {
  outline: 0;
  background: #f0f4f3;
}

.qa-context-option.is-selected {
  background: #eaf4f1;
  color: #176852;
}

.qa-context-option > i {
  width: 13px;
  flex: 0 0 13px;
  visibility: hidden;
  font-size: 12px;
  text-align: center;
}

.qa-context-option.is-selected > i {
  visibility: visible;
}

.qa-context-option > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-approval-toggle {
  display: inline-flex;
  height: 37px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 10px;
  border: 1px solid #cbd6da;
  background: #fff;
  color: #465760;
}

.qa-approval-toggle em {
  min-width: 18px;
  padding: 2px 5px;
  background: #e9eef0;
  color: #57666f;
  font-style: normal;
  text-align: center;
}

.qa-approval-toggle:hover,
.qa-approval-toggle.is-active {
  border-color: #438b78;
  background: #edf7f3;
  color: #1f6a57;
}

.qa-approval-toggle.is-active em {
  background: #d4e9e2;
  color: #1c6653;
}

.qa-conversation {
  min-height: 0;
  overflow-y: auto;
  background: #f8fafb;
  scroll-behavior: smooth;
}

.qa-conversation-inner {
  width: min(100% - 40px, 900px);
  min-height: 100%;
  margin: 0 auto;
  padding: 28px 0 34px;
}

.qa-conversation.is-empty .qa-conversation-inner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.qa-conversation-empty {
  display: grid;
  max-width: 660px;
  justify-items: center;
  color: #586871;
  text-align: center;
}

.qa-conversation-empty h2 {
  margin: 14px 0 0;
  color: #22313a;
  font-size: 20px;
  letter-spacing: 0;
}

.qa-conversation-empty > p {
  margin: 7px 0 0;
  color: #7b888f;
  font-size: 12px;
}

.qa-exchange + .qa-exchange {
  margin-top: 38px;
}

.qa-exchange__request-wrap {
  max-width: 72%;
  margin-left: auto;
}

.qa-exchange__request {
  padding: 11px 13px 8px;
  border: 1px solid #e0e4e5;
  border-radius: 8px;
  background: #f1f3f3;
  color: #26353d;
}

.qa-exchange__request-meta {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 7px;
}

.qa-exchange__request-meta span {
  color: #8b969b;
  font-size: 12px;
}

.qa-exchange__request-meta em {
  padding: 2px 5px;
  border: 1px solid #d8dfe1;
  border-radius: 4px;
  background: #fff;
  color: #68777f;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.qa-message-context {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 5px;
  margin-top: 8px;
}

.qa-message-context > span {
  display: inline-flex;
  height: 25px;
  min-width: 0;
  max-width: 100%;
  align-items: center;
  gap: 5px;
  padding: 0 7px;
  border: 1px solid #d4dfe5;
  border-radius: 4px;
  background: #eef3f7;
  color: #3a5666;
}

.qa-message-context > span[data-kind=survey] {
  border-color: #e5dac3;
  background: #f7f2e9;
  color: #745b2c;
}

.qa-message-context > span[data-kind=harness] {
  border-color: #cfe3db;
  background: #edf6f2;
  color: #276b58;
}

.qa-message-context > span.is-all {
  border-color: #dce2e4;
  background: #f7f8f8;
  color: #76838a;
}

.qa-message-context i {
  flex: 0 0 auto;
  font-size: 12px;
}

.qa-message-context em {
  flex: 0 0 auto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  opacity: 0.76;
}

.qa-message-context strong {
  overflow: hidden;
  min-width: 0;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-exchange__request p,
.qa-answer-copy {
  margin: 0;
  white-space: pre-wrap;
  font-size: 13px;
  line-height: 1.7;
}

.qa-message-files {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 5px;
  margin-top: 7px;
}

.qa-message-files a {
  display: inline-flex;
  max-width: 210px;
  align-items: center;
  gap: 5px;
  padding: 4px 7px;
  border-radius: 5px;
  background: #fff;
  color: #356456;
  font-size: 12px;
  text-decoration: none;
}

.qa-message-files a span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-message-tools {
  display: flex;
  height: 28px;
  align-items: center;
  gap: 5px;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-2px);
  transition: opacity 120ms ease, transform 120ms ease;
}

.qa-message-tools--request {
  justify-content: flex-end;
  padding-right: 4px;
}

.qa-message-tools--answer {
  margin-top: 3px;
}

.qa-message-tools time {
  color: #87949a;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

.qa-message-copy {
  display: inline-flex;
  width: 26px;
  height: 26px;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: #75838a;
  cursor: pointer;
}

.qa-message-copy:hover,
.qa-message-copy:focus-visible {
  outline: 0;
  background: #e9eeef;
  color: #263b44;
}

.qa-message-copy.is-copied {
  color: #24715e;
}

.qa-exchange__request-wrap:hover > .qa-message-tools,
.qa-exchange__request-wrap:focus-within > .qa-message-tools,
.qa-exchange__answer:hover .qa-message-tools,
.qa-exchange__answer:focus-within .qa-message-tools {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

.qa-exchange__answer {
  display: grid;
  min-width: 0;
  margin-top: 20px;
  grid-template-columns: 30px minmax(0, 1fr);
  align-items: start;
  gap: 11px;
}

.qa-exchange__answer-content {
  min-width: 0;
  padding-top: 2px;
}

.qa-exchange__answer-content > header {
  gap: 7px;
  min-height: 24px;
  margin-bottom: 7px;
}

.qa-exchange__answer-content > header strong {
  font-size: 12px;
}

.qa-exchange__answer-content > header time {
  margin-left: auto;
  color: #929da2;
  font-size: 12px;
}

.qa-exchange__answer-content > header em {
  padding: 2px 6px;
  border-radius: 4px;
  background: #edf2f4;
  color: #66747b;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.qa-exchange__answer-content > header em[data-severity=warning] {
  background: #fff1dc;
  color: #9a621a;
}

.qa-exchange__answer-content > header em[data-severity=critical] {
  background: #fde9e8;
  color: #a83434;
}

.qa-exchange__answer.is-pending {
  color: #62727b;
}

.qa-answer-copy {
  color: #27363e;
  overflow-wrap: anywhere;
}

.qa-answer-copy strong {
  color: #18272f;
  font-weight: 700;
}

.qa-answer-copy code {
  padding: 2px 4px;
  border-radius: 4px;
  background: #eef1f2;
  color: #31554b;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.9em;
}

.qa-answer-action {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 0 12px;
  border: 1px solid #236f5c;
  background: #236f5c;
  color: #fff;
  cursor: pointer;
  font: inherit;
}

.qa-answer-action:hover {
  background: #195f4e;
}

.qa-generation-jobs {
  display: grid;
  gap: 10px;
  margin: 22px 0 4px 41px;
}

.qa-generation-job {
  padding: 13px 14px;
  border: 1px solid #d6e1de;
  border-radius: 7px;
  background: #f8fbfa;
}

.qa-generation-job[data-status=failed] {
  border-color: #e7c1bf;
  background: #fff7f6;
}

.qa-generation-job[data-status=completed] {
  border-color: #bcd9d0;
  background: #f5fbf8;
}

.qa-generation-job > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.qa-generation-job > header > div {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 9px;
}

.qa-generation-job > header > div > i {
  margin-top: 2px;
  color: #277661;
}

.qa-generation-job[data-status=failed] > header > div > i {
  color: #b6403b;
}

.qa-generation-job > header span {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.qa-generation-job > header strong {
  color: #24343c;
  font-size: 12px;
}

.qa-generation-job > header small {
  color: #6e7d85;
  font-size: 12px;
}

.qa-generation-job > header em {
  flex: 0 0 auto;
  color: #26725f;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.qa-generation-progress {
  height: 5px;
  overflow: hidden;
  margin: 12px 0 8px;
  border-radius: 3px;
  background: #dfe8e5;
}

.qa-generation-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #2a8069;
  transition: width 0.25s ease;
}

.qa-generation-job dl {
  display: flex;
  gap: 18px;
  margin: 9px 0 0;
}

.qa-generation-job dl div {
  display: flex;
  gap: 5px;
  font-size: 12px;
}

.qa-generation-job dt {
  color: #7e8a90;
}

.qa-generation-job dd {
  margin: 0;
  color: #43545d;
  font-weight: 700;
}

.qa-generation-job footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.qa-answer-copy--streaming {
  min-height: 21px;
}

.qa-stream-cursor {
  display: inline-block;
  width: 2px;
  height: 1.05em;
  margin-left: 2px;
  background: #2b7965;
  vertical-align: -0.12em;
  animation: qa-stream-cursor 1s steps(1, end) infinite;
}

.qa-stream-placeholder {
  display: flex;
  min-height: 21px;
  align-items: center;
  gap: 4px;
}

.qa-stream-placeholder span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #7f958e;
  animation: qa-stream-dot 1.1s ease-in-out infinite;
}

.qa-stream-placeholder span:nth-child(2) {
  animation-delay: 0.14s;
}

.qa-stream-placeholder span:nth-child(3) {
  animation-delay: 0.28s;
}

.qa-stream-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 11px;
}

.qa-stream-actions button {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  gap: 6px;
  padding: 0 9px;
  border: 1px solid #d4dde0;
  background: #fff;
  color: #53636b;
  cursor: pointer;
  font: inherit;
}

.qa-stream-actions button:hover {
  border-color: #94aaa4;
  background: #f1f6f4;
  color: #1f6957;
}

.qa-stream-actions button:disabled {
  cursor: wait;
  opacity: 0.55;
}

@keyframes qa-stream-dot {
  0%, 60%, 100% {
    opacity: 0.28;
    transform: translateY(0);
  }
  30% {
    opacity: 1;
    transform: translateY(-2px);
  }
}
@keyframes qa-stream-cursor {
  0%, 52% {
    opacity: 1;
  }
  53%, 100% {
    opacity: 0;
  }
}
.qa-findings {
  margin: 14px 0 0;
  padding: 3px 12px;
  border-left: 2px solid #6a9f91;
  background: #f4f7f6;
  list-style: none;
}

.qa-findings li {
  display: grid;
  gap: 3px;
  padding: 8px 0;
}

.qa-findings li + li {
  border-top: 1px solid #dfe7e4;
}

.qa-findings strong {
  font-size: 12px;
}

.qa-findings span {
  color: #495962;
  font-size: 12px;
  line-height: 1.5;
}

.qa-findings small {
  color: #26715e;
  font-size: 12px;
}

.qa-approval-backdrop {
  position: absolute;
  z-index: 8;
  top: var(--qa-chat-header-height);
  right: 0;
  bottom: 0;
  left: 0;
  border: 0;
  background: rgba(25, 40, 48, 0.16);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.15s ease, visibility 0s linear 0.15s;
}

.qa-approval-backdrop.is-open {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transition-delay: 0s;
}

.qa-approval-drawer {
  position: absolute;
  z-index: 9;
  top: var(--qa-chat-header-height);
  right: 0;
  bottom: 0;
  display: grid;
  width: min(400px, 92%);
  min-width: 0;
  grid-template-rows: auto minmax(0, 1fr);
  border-left: 1px solid #d5dde0;
  background: #fff;
  box-shadow: -12px 0 28px rgba(31, 45, 54, 0.12);
  transform: translateX(100%);
  visibility: hidden;
  pointer-events: none;
  transition: transform 0.18s cubic-bezier(0.22, 0.72, 0.22, 1), visibility 0s linear 0.18s;
}

.qa-approval-drawer[aria-hidden=true] {
  box-shadow: none;
}

.qa-approval-drawer.is-open {
  box-shadow: -12px 0 28px rgba(31, 45, 54, 0.12);
  transform: translateX(0);
  visibility: visible;
  pointer-events: auto;
  transition-delay: 0s;
}

.qa-approval-drawer__header {
  min-height: 70px;
  gap: 10px;
  padding: 13px 16px;
  border-bottom: 1px solid #e0e6e8;
}

.qa-approval-drawer__header > div {
  display: grid;
  flex: 1;
  gap: 2px;
}

.qa-approval-drawer__header span {
  color: #77858c;
  font-size: 12px;
  font-weight: 700;
}

.qa-approval-drawer__header h2 {
  margin: 0;
  font-size: 15px;
  letter-spacing: 0;
}

.qa-approval-drawer__header > em {
  min-width: 25px;
  padding: 4px 6px;
  border-radius: 5px;
  background: #eaf0f2;
  color: #52636c;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  text-align: center;
}

.qa-approval-drawer__body {
  min-height: 0;
  overflow-y: auto;
  padding: 14px;
  background: #f7f9fa;
}

.qa-approval-empty {
  display: grid;
  justify-items: center;
  gap: 7px;
  padding: 50px 18px;
  color: #78868d;
  text-align: center;
}

.qa-approval-empty i {
  color: #2c806b;
  font-size: 21px;
}

.qa-approval-empty strong {
  color: #3a4b54;
  font-size: 12px;
}

.qa-approval-empty span {
  font-size: 12px;
  line-height: 1.5;
}

.qa-drawer-proposal {
  padding: 13px;
  border: 1px solid #d7e0e3;
  border-radius: 7px;
  background: #fff;
}

.qa-drawer-proposal + .qa-drawer-proposal {
  margin-top: 10px;
}

.qa-drawer-proposal > header {
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.qa-drawer-proposal > header > div {
  min-width: 0;
  align-items: flex-start;
  flex-direction: column;
  gap: 3px;
}

.qa-drawer-proposal > header span {
  color: #28715e;
  font-size: 12px;
  font-weight: 700;
}

.qa-drawer-proposal > header strong {
  font-size: 12px;
  line-height: 1.45;
}

.qa-drawer-proposal > header em,
.qa-approval-history article > em {
  flex: 0 0 auto;
  padding: 3px 6px;
  border-radius: 4px;
  background: #fff0dc;
  color: #9a6118;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.qa-drawer-proposal > p {
  margin: 9px 0 0;
  color: #596871;
  font-size: 12px;
  line-height: 1.55;
}

.qa-drawer-proposal dl {
  display: grid;
  gap: 5px;
  margin: 10px 0 0;
}

.qa-drawer-proposal dl div {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  gap: 7px;
  padding: 6px 7px;
  border-radius: 4px;
  background: #eef2f3;
  font-size: 12px;
}

.qa-drawer-proposal dt {
  color: #7b878d;
}

.qa-drawer-proposal dd {
  overflow-wrap: anywhere;
  margin: 0;
  color: #34464f;
  font-weight: 700;
}

.qa-rule-summary {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 9px;
  color: #2b735f;
  font-size: 12px;
  font-weight: 700;
}

.qa-drawer-proposal footer {
  justify-content: flex-end;
  gap: 7px;
  margin-top: 12px;
}

.qa-approval-history {
  margin-top: 14px;
  border-top: 1px solid #d9e1e4;
}

.qa-approval-history summary {
  padding: 13px 2px 9px;
  color: #596972;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
}

.qa-approval-history article {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 8px;
  padding: 10px;
  border: 1px solid #dce3e6;
  border-radius: 6px;
  background: #fff;
}

.qa-approval-history article + article {
  margin-top: 7px;
}

.qa-approval-history article > div {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.qa-approval-history article strong {
  font-size: 12px;
  line-height: 1.4;
}

.qa-approval-history article span {
  overflow: hidden;
  color: #7a878e;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-approval-history article > em {
  background: #e7f3ef;
  color: #226a58;
}

.qa-approval-history article > button {
  grid-column: 1/-1;
  justify-self: end;
}

.qa-primary-button,
.qa-secondary-button {
  display: inline-flex;
  min-height: 33px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 12px;
}

.qa-primary-button {
  border: 1px solid #216f5c;
  background: #216f5c;
  color: #fff;
}

.qa-primary-button.is-danger {
  border-color: #b13b3b;
  background: #b13b3b;
}

.qa-secondary-button {
  border: 1px solid #cbd5d9;
  background: #fff;
  color: #44545d;
}

.qa-primary-button:disabled,
.qa-secondary-button:disabled {
  opacity: 0.55;
}

.qa-request-queue {
  min-height: 0;
  border-top: 1px solid #dce3e5;
  background: #f7f9f9;
}

.qa-request-queue__inner {
  width: min(100% - 40px, 900px);
  margin: 0 auto;
  padding: 8px 0;
}

.qa-request-queue__header {
  display: flex;
  min-height: 25px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 5px 6px;
  color: #6e7c84;
  font-size: 12px;
}

.qa-request-queue__header > div {
  display: flex;
  align-items: center;
  gap: 6px;
}

.qa-request-queue__header i {
  color: #28745f;
}

.qa-request-queue__header strong {
  color: #35464f;
  font-size: 12px;
}

.qa-request-queue__header em {
  min-width: 18px;
  padding: 2px 5px;
  border-radius: 4px;
  background: #e1ebe7;
  color: #216b58;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  text-align: center;
}

.qa-request-queue__list {
  max-height: 160px;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #d8e0e2;
  border-radius: 7px;
  background: #fff;
}

.qa-queue-item {
  position: relative;
  display: grid;
  min-width: 0;
  min-height: 52px;
  grid-template-columns: 30px minmax(0, 1fr) auto 32px 32px;
  align-items: center;
  gap: 5px;
  padding: 7px 8px 7px 5px;
  background: #fff;
  transition: background-color 0.12s ease, opacity 0.12s ease;
}

.qa-queue-item + .qa-queue-item {
  border-top: 1px solid #e4e9eb;
}

.qa-queue-item.is-next {
  background: #fbfdfc;
}

.qa-queue-item.is-failed {
  background: #fff9f8;
}

.qa-queue-item.is-dragging {
  opacity: 0.46;
}

.qa-queue-item.is-drop-before::before,
.qa-queue-item.is-drop-after::after {
  position: absolute;
  z-index: 2;
  right: 8px;
  left: 8px;
  height: 2px;
  border-radius: 1px;
  background: #28745f;
  content: "";
}

.qa-queue-item.is-drop-before::before {
  top: -1px;
}

.qa-queue-item.is-drop-after::after {
  bottom: -1px;
}

.qa-queue-handle,
.qa-queue-action,
.qa-queue-item__editor button {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: #87949a;
}

.qa-queue-handle {
  cursor: grab;
  touch-action: none;
}

.qa-queue-handle.is-active {
  cursor: grabbing;
  background: #e7f1ed;
  color: #236e5b;
}

.qa-queue-action:hover,
.qa-queue-handle:hover {
  background: #eef2f3;
  color: #465760;
}

.qa-queue-item__content {
  display: grid;
  min-width: 0;
  gap: 3px;
  padding: 0 5px;
}

.qa-queue-item__content > div {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
}

.qa-queue-item__content p {
  overflow: hidden;
  margin: 0;
  color: #26363e;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-queue-item__content em {
  flex: 0 0 auto;
  padding: 2px 5px;
  border-radius: 4px;
  background: #e5f1ed;
  color: #216b58;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.qa-queue-item__content em.qa-queue-error {
  background: #fde9e7;
  color: #a33935;
}

.qa-queue-item__content small {
  color: #8a969c;
  font-size: 12px;
}

.qa-queue-steer {
  display: inline-flex;
  height: 31px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 9px;
  border: 0;
  background: transparent;
  color: #69777e;
  white-space: nowrap;
}

.qa-queue-steer:hover {
  background: #edf4f1;
  color: #206a57;
}

.qa-queue-item__editor {
  display: grid;
  min-width: 0;
  grid-column: 2/-1;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
}

.qa-queue-item__editor textarea {
  width: 100%;
  min-height: 38px;
  max-height: 90px;
  resize: vertical;
  padding: 8px 9px;
  border: 1px solid #85aa9e;
  border-radius: 5px;
  outline: 0;
  background: #fff;
  color: #25353d;
  font: inherit;
  font-size: 12px;
  line-height: 1.45;
}

.qa-queue-item__editor textarea:focus {
  box-shadow: 0 0 0 2px rgba(42, 126, 104, 0.11);
}

.qa-queue-item__editor > div {
  display: flex;
  gap: 3px;
}

.qa-queue-item__editor button:hover {
  background: #eef2f3;
  color: #465760;
}

.qa-queue-item__editor button.qa-queue-save {
  background: #216f5c;
  color: #fff;
}

.qa-queue-item__editor button:disabled {
  opacity: 0.45;
}

.qa-composer {
  border-top: 1px solid #e1e7e9;
  background: #fff;
}

.qa-composer-inner {
  width: min(100% - 40px, 900px);
  margin: 0 auto;
  padding: 11px 0 13px;
}

.qa-composer-box {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) 38px;
  align-items: center;
  gap: 8px;
  padding: 7px 7px 7px 13px;
  border: 1px solid #cbd6da;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 3px 10px rgba(34, 51, 61, 0.04);
}

.qa-composer-box.is-asking {
  grid-template-columns: 36px minmax(0, 1fr) 38px 38px;
}

.qa-composer-box:focus-within {
  border-color: #6a9f91;
  box-shadow: 0 0 0 2px rgba(42, 126, 104, 0.1);
}

.qa-chat-main .qa-composer .qa-composer-box > textarea.qa-composer-input {
  width: 100%;
  height: 36px;
  min-height: 36px;
  max-height: 140px;
  margin: 0 !important;
  resize: none;
  overflow-y: hidden;
  border: 0 !important;
  border-radius: 0 !important;
  outline: 0 !important;
  padding: 8px 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  color: #203039;
  font: inherit;
  font-size: 12px;
  line-height: 1.55;
}

.qa-chat-main .qa-composer .qa-composer-box > textarea.qa-composer-input:focus,
.qa-chat-main .qa-composer .qa-composer-box > textarea.qa-composer-input:focus-visible {
  border: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
}

.qa-send-button,
.qa-stop-button {
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border: 0;
  background: #216f5c;
  color: #fff;
}

.qa-attach-button {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  align-self: center;
  color: #63747d;
  cursor: pointer;
}

.qa-attach-button:hover {
  background: #edf2f3;
  color: #216f5c;
}

.qa-attach-button.is-loading {
  cursor: wait;
}

.qa-attach-button input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

.qa-attachment-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 7px;
}

.qa-attachment-list > span {
  display: inline-flex;
  max-width: 240px;
  height: 29px;
  align-items: center;
  gap: 6px;
  padding: 0 6px 0 9px;
  border: 1px solid #d2dcdf;
  border-radius: 6px;
  background: #f7f9f9;
  color: #42545d;
  font-size: 12px;
}

.qa-attachment-list em {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-style: normal;
}

.qa-attachment-list button {
  display: inline-flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: #75848b;
}

.qa-send-button:disabled {
  background: #d5dcdf;
  color: #829097;
}

.qa-stop-button {
  background: #303c42;
  cursor: pointer;
}

.qa-stop-button:hover {
  background: #202a2f;
}

.qa-stop-button:disabled {
  cursor: wait;
  opacity: 0.55;
}

.qa-composer__footer {
  justify-content: flex-end;
  gap: 12px;
  padding: 7px 2px 0;
  color: #74828a;
  font-size: 12px;
}

.qa-composer__footer i {
  margin-right: 5px;
}

.qa-composer__footer small {
  font-size: 12px;
}

.qa-model-picker {
  position: relative;
  margin-right: auto;
}

.qa-model-picker__trigger {
  display: inline-flex;
  max-width: 230px;
  min-height: 28px;
  align-items: center;
  gap: 9px;
  padding: 4px 10px;
  border: 1px solid #d8e0e2;
  background: #f4f7f6;
  color: #40535b;
  cursor: pointer;
}

.qa-model-picker__trigger span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-model-picker__trigger i {
  flex: none;
  margin: 0;
  font-size: 12px;
}

.qa-model-picker__trigger:hover,
.qa-model-picker__trigger:focus-visible {
  border-color: #90b4a8;
  color: #216f5c;
  outline: none;
}

.qa-model-picker__menu {
  position: absolute;
  z-index: 25;
  bottom: calc(100% + 8px);
  left: 0;
  width: min(280px, 100vw - 32px);
  max-height: min(390px, 65vh);
  overflow-y: auto;
  padding: 8px;
  border: 1px solid #454545;
  border-radius: 16px;
  background: #2c2c2c;
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.24);
  color: #f5f5f5;
}

.qa-model-picker__heading {
  display: block;
  padding: 5px 11px 8px;
  color: #a7a7a7;
  font-size: 12px;
  font-weight: 700;
}

.qa-model-picker__option {
  display: flex;
  width: 100%;
  min-height: 41px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 11px;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  text-align: left;
}

.qa-model-picker__option:hover,
.qa-model-picker__option:focus-visible {
  background: #414141;
  outline: none;
}

.qa-model-picker__option > span {
  display: grid;
  gap: 2px;
}

.qa-model-picker__option small {
  color: #aaa;
}

.qa-model-picker__option i {
  margin: 0;
  color: #c9d3d0;
}

@media (max-width: 1050px) {
  .qa-chat-shell {
    grid-template-columns: 220px minmax(0, 1fr);
  }
  .qa-chat-main {
    --qa-chat-header-height: 116px;
  }
  .qa-chat-header__actions {
    width: 100%;
    flex: none;
  }
  .qa-chat-context {
    flex: 1;
    justify-content: flex-start;
  }
  .qa-context-picker {
    width: min(230px, 33.333%);
  }
}
@media (max-width: 720px) {
  /* Share the available height; allow both panes to remain reachable on short screens. */
  .qa-chat-shell {
    width: 100%;
    height: 100%;
    min-height: 0;
    overflow-y: auto;
    grid-template-columns: 1fr;
    grid-template-rows: minmax(300px, 2fr) minmax(280px, 3fr);
  }
  .qa-chat-sidebar {
    padding: 10px 12px;
    grid-template-rows: auto auto auto minmax(0, 1fr);
    border-right: 0;
    border-bottom: 1px solid #e1e6e8;
  }
  .qa-chat-sidebar__header {
    display: none;
  }
  .qa-new-chat {
    height: 36px;
    margin-top: 0;
  }
  .qa-history-heading {
    padding: 10px 3px 5px;
  }
  .qa-chat-history {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 6px;
    overflow-x: hidden;
    overflow-y: auto;
    scroll-padding-block: 4px;
  }
  /* Expanded children keep their height; the history nav owns vertical scrolling. */
  .qa-chat-history > .qa-history-project,
  .qa-chat-history > .qa-history-direct,
  .qa-chat-history > .qa-history-section-header,
  .qa-chat-history > .qa-history-empty {
    flex: 0 0 auto;
  }
  .qa-chat-history button:focus-visible {
    outline-offset: -2px;
  }
  .qa-history-entry {
    width: 100%;
    min-width: 0;
  }
  .qa-history-entry + .qa-history-entry {
    margin-top: 0;
  }
  .qa-history-item {
    width: 100%;
    min-width: 0;
    min-height: 46px;
  }
  .qa-history-delete,
  .qa-history-edit {
    opacity: 1;
  }
  .qa-history-delete:disabled,
  .qa-history-edit:disabled {
    opacity: 0.35;
  }
  .qa-history-empty {
    display: flex;
    padding: 12px 4px;
  }
  .qa-chat-sidebar__footer {
    display: none;
  }
  .qa-chat-title p {
    display: none;
  }
  .qa-chat-header__actions {
    gap: 6px;
  }
  .qa-chat-context {
    gap: 6px;
  }
  .qa-chat-context {
    display: grid;
    overflow: visible;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .qa-context-picker {
    width: 100%;
    min-width: 0;
  }
  .qa-approval-toggle {
    padding: 0 8px;
  }
  .qa-approval-toggle span {
    display: none;
  }
  .qa-approval-drawer {
    width: min(400px, 100%);
  }
  .qa-conversation-inner,
  .qa-composer-inner,
  .qa-request-queue__inner {
    width: calc(100% - 24px);
  }
  .qa-conversation-inner {
    padding-top: 20px;
  }
  .qa-exchange__request-wrap {
    max-width: 90%;
  }
  .qa-request-queue__header > span {
    display: none;
  }
  .qa-request-queue__list {
    max-height: 142px;
  }
  .qa-queue-item {
    grid-template-columns: 28px minmax(0, 1fr) 32px 32px 32px;
    gap: 2px;
    padding-right: 5px;
  }
  .qa-queue-steer {
    width: 32px;
    padding: 0;
  }
  .qa-queue-steer span {
    display: none;
  }
  .qa-composer__footer > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .qa-composer__footer small {
    display: none;
  }
  .qa-operator-alert {
    top: 10px;
    right: 12px;
    max-width: calc(100% - 24px);
  }
  .qa-codex-dialog {
    max-height: calc(100% - 24px);
    overflow-y: auto;
    padding: 26px 18px 18px;
  }
  .qa-codex-device {
    padding: 15px 13px 13px;
  }
  .qa-codex-device__code {
    flex-wrap: wrap;
  }
  .qa-codex-dialog footer {
    display: grid;
    grid-template-columns: 1fr;
  }
  .qa-codex-dialog footer button,
  .qa-codex-dialog footer a {
    width: 100%;
  }
}
@media (hover: none), (pointer: coarse) {
  .qa-message-tools {
    opacity: 1;
    pointer-events: auto;
    transform: none;
  }
}
.qa-history-row:hover .qa-history-delete:disabled,
.qa-history-row:hover .qa-history-edit:disabled {
  opacity: 0.35;
}

/* 11: workspace information hierarchy and shared component roles. */
:host-context(.reviewops-shell) .qa-operator-page .qa-chat-header__actions {
  gap: 8px;
}
:host-context(.reviewops-shell) .qa-operator-page .qa-chat-context {
  font-size: 14px;
  line-height: 22px;
}
:host-context(.reviewops-shell) .qa-operator-page .qa-approval-drawer__header {
  gap: 12px;
}
:host-context(.reviewops-shell) .qa-operator-page .qa-drawer-proposal {
  border: 1px solid var(--ro-line);
  border-radius: 12px;
  padding: 16px;
}
:host-context(.reviewops-shell) .qa-operator-page .qa-drawer-proposal footer {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
:host-context(.reviewops-shell) .qa-operator-page .qa-drawer-proposal dd {
  margin-inline: 0;
  white-space: normal;
  overflow-wrap: anywhere;
}
@media (min-width: 1024px) {
  :host-context(.reviewops-shell) .qa-operator-page .qa-chat-title {
    flex: 1 1 200px;
  }
  :host-context(.reviewops-shell) .qa-operator-page .qa-chat-header__actions {
    flex: 2 1 540px;
  }
  :host-context(.reviewops-shell) .qa-operator-page .qa-chat-context {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    flex: 1 1 360px;
  }
  :host-context(.reviewops-shell) .qa-operator-page .qa-context-picker {
    width: 100%;
    height: auto;
  }
  :host-context(.reviewops-shell) .qa-operator-page .qa-context-trigger > span {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    word-break: keep-all;
    overflow-wrap: anywhere;
  }
  :host-context(.reviewops-shell) .qa-operator-page .qa-chat-sidebar {
    padding: 8px 12px 10px;
  }
  :host-context(.reviewops-shell) .qa-operator-page .qa-new-chat {
    margin-top: 8px;
  }
  :host-context(.reviewops-shell) .qa-operator-page .qa-history-heading {
    padding: 8px 4px 4px;
  }
  :host-context(.reviewops-shell) .qa-operator-page .qa-chat-sidebar__footer {
    gap: 4px;
    padding-top: 8px;
  }
}`],
})
export class PageQaOperatorComponent implements OnInit, OnDestroy {
    public overview: any = {
        projects: [], surveys: [], harnesses: [], recent_errors: [], proposals: [], activity: [], runtime: {}
    };
    public message: string = '';
    public selectedProjectId: string = '';
    public selectedSurveyId: string = '';
    public selectedHarnessId: string = '';
    public contextMenu: string = '';
    public activeConversationId: string = '';
    public loading: boolean = true;
    public asking: boolean = false;
    public actionId: string = '';
    public errorMessage: string = '';
    public approvalDrawerOpen: boolean = false;
    public lastAnswer: any = null;
    public pendingRequest: any = null;
    public queuedRequests: any[] = [];
    public editingQueueId: string = '';
    public queueEditMessage: string = '';
    public draggingQueueId: string = '';
    public confirmDeleteConversationId: string = '';
    public deletingConversationId: string = '';
    public historySearch: string = '';
    public expandedHistoryProjectIds: Set<string> = new Set<string>();
    public projectHistoryVisibleCounts: { [projectId: string]: number } = {};
    public readonly projectHistoryPageSize: number = 5;
    public projectHistorySectionExpanded: boolean = true;
    public directHistorySectionExpanded: boolean = true;
    public editingConversationId: string = '';
    public renamingConversationId: string = '';
    public attachments: any[] = [];
    public uploadingFile: boolean = false;
    public generationActionId: string = '';
    public stopping: boolean = false;
    public copiedMessageKey: string = '';
    public codexAuth: any = {
        available: true, connected: false, state: 'disconnected', runtime: 'codex-cli',
        auth_mode: 'device', verification_uri: '', user_code: '', remaining_seconds: 0,
        account: null, message: ''
    };
    public codexAuthLoading: boolean = true;
    public codexAuthDialogOpen: boolean = false;
    public codexAuthStarting: boolean = false;
    public codexDisconnecting: boolean = false;
    public codexCodeCopied: boolean = false;
    public selectedModel: string = '';
    public modelMenuOpen: boolean = false;
    private readonly endpoint: string = '/api/v1/review-workspace/operator';
    private activeStreamController: AbortController | null = null;
    private activeRequest: any = null;
    private stopRequested: boolean = false;
    private stopForEdit: boolean = false;
    private renderInFlight: Promise<void> | null = null;
    private renderQueued: boolean = false;
    private streamFrame: number | null = null;
    private queueHoldTimer: number | null = null;
    private queuePointerId: number | null = null;
    private queuePointerStart: { x: number; y: number } | null = null;
    private queueHandle: HTMLElement | null = null;
    private queueDropTargetId: string = '';
    private queueDropAfter: boolean = false;
    private jobPollTimer: number | null = null;
    private copyResetTimer: number | null = null;
    private codexCopyResetTimer: number | null = null;
    private codexAuthPollTimer: number | null = null;
    private projectHistoryInitialized: boolean = false;
    private deletedConversationIds: Set<string> = new Set<string>();
    private readonly contextOutsideHandler = (event: PointerEvent) => {
        const target = event.target;
        if (!this.contextMenu || (target instanceof Element && target.closest('.qa-context-picker'))) return;
        this.contextMenu = '';
        this.syncContextMenuDom();
    };
    private readonly modelOutsideHandler = (event: PointerEvent) => {
        if (!this.modelMenuOpen || (event.target instanceof Element && event.target.closest('.qa-model-picker'))) return;
        this.modelMenuOpen = false;
        void this.renderView();
    };
    private readonly modelSelectionHandler = () => {
        this.selectedModel = this.storedModel();
        void this.renderView();
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        document.addEventListener('pointerdown', this.contextOutsideHandler);
        document.addEventListener('pointerdown', this.modelOutsideHandler);
        window.addEventListener('storage', this.modelSelectionHandler);
        window.addEventListener('reviewops:model-selection-changed', this.modelSelectionHandler);
        this.selectedModel = this.storedModel();
        await this.service.init();
        await this.loadOverview();
        await this.loadCodexAuth();
        this.jobPollTimer = window.setInterval(() => {
            if ((this.overview.jobs || []).some((job: any) => ['starting', 'running', 'cancel_requested'].includes(job?.status))) {
                void this.refreshOverviewSilently();
            }
        }, 2000);
    }

    public ngOnDestroy() {
        document.removeEventListener('pointerdown', this.contextOutsideHandler);
        document.removeEventListener('pointerdown', this.modelOutsideHandler);
        window.removeEventListener('storage', this.modelSelectionHandler);
        window.removeEventListener('reviewops:model-selection-changed', this.modelSelectionHandler);
        this.activeStreamController?.abort();
        if (this.jobPollTimer !== null) window.clearInterval(this.jobPollTimer);
        if (this.copyResetTimer !== null) window.clearTimeout(this.copyResetTimer);
        if (this.codexCopyResetTimer !== null) window.clearTimeout(this.codexCopyResetTimer);
        this.stopCodexAuthPolling();
    }

    public async loadOverview() {
        this.loading = true;
        this.errorMessage = '';
        this.clearErrorDom();
        this.syncRefreshDom(true);
        try {
            const response = await fetch(this.endpoint, {
                method: 'GET',
                credentials: 'same-origin',
                cache: 'no-store',
                headers: { Accept: 'application/json' }
            });
            const payload = await this.readPayload(response);
            const requestError = this.responseError(response, payload, '운영 현황을 불러오지 못했습니다.');
            if (requestError) throw requestError;
            this.overview = this.unwrap(payload);
            this.ensureOverviewShape();
            this.ensureActiveConversation();
            this.initializeProjectHistory();
        } catch (error: any) {
            this.errorMessage = error?.message || '운영 현황을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            this.syncRefreshDom(false);
            await this.renderView();
        }
    }

    public async toggleApprovalDrawer() {
        this.approvalDrawerOpen = !this.approvalDrawerOpen;
        this.syncApprovalDrawerDom();
    }

    public toggleContextMenu(type: string) {
        if (!['project', 'survey', 'harness'].includes(type)) return;
        this.contextMenu = this.contextMenu === type ? '' : type;
        this.syncContextMenuDom();
        if (this.contextMenu) requestAnimationFrame(() => this.focusContextOption(type));
    }

    public selectContextValue(type: string, value: string) {
        if (type === 'project') this.selectedProjectId = value;
        if (type === 'survey') this.selectedSurveyId = value;
        if (type === 'harness') this.selectedHarnessId = value;
        this.contextMenu = '';
        this.syncContextMenuDom();
        const label = document.querySelector(`[data-context-picker="${type}"] .qa-context-trigger span`);
        if (label) label.textContent = this.contextLabel(type);
        void this.renderView();
    }

    public contextValue(type: string) {
        if (type === 'project') return this.selectedProjectId;
        if (type === 'survey') return this.selectedSurveyId;
        return this.selectedHarnessId;
    }

    public contextLabel(type: string) {
        if (type === 'project') return this.selectedProjectId ? this.projectName(this.selectedProjectId) : '전체 프로젝트';
        if (type === 'survey') return this.selectedSurveyId ? this.surveyName(this.selectedSurveyId) : '전체 설문지';
        return this.selectedHarnessId ? this.harnessName(this.selectedHarnessId) : '전체 하네스';
    }

    public onContextTriggerKeydown(event: KeyboardEvent, type: string) {
        if (!['Enter', ' ', 'ArrowDown'].includes(event.key)) {
            if (event.key === 'Escape' && this.contextMenu) {
                event.preventDefault();
                this.contextMenu = '';
                this.syncContextMenuDom();
            }
            return;
        }
        event.preventDefault();
        this.contextMenu = type;
        this.syncContextMenuDom();
        requestAnimationFrame(() => this.focusContextOption(type));
    }

    public onContextOptionKeydown(event: KeyboardEvent, type: string) {
        const options = Array.from(
            document.querySelectorAll(`[data-context-menu="${type}"] .qa-context-option`)
        ) as HTMLButtonElement[];
        const current = options.indexOf(document.activeElement as HTMLButtonElement);
        let next = current;
        if (event.key === 'ArrowDown') next = Math.min(options.length - 1, current + 1);
        else if (event.key === 'ArrowUp') next = Math.max(0, current - 1);
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = options.length - 1;
        else if (event.key === 'Escape') {
            event.preventDefault();
            this.contextMenu = '';
            this.syncContextMenuDom();
            (document.querySelector(`[data-context-picker="${type}"] .qa-context-trigger`) as HTMLButtonElement)?.focus();
            return;
        } else return;
        event.preventDefault();
        options[next]?.focus();
    }

    public dismissError() {
        this.errorMessage = '';
        this.clearErrorDom();
    }

    public async newChat() {
        if (this.asking) return;
        this.activeConversationId = this.createConversationId();
        this.selectedProjectId = '';
        this.selectedSurveyId = '';
        this.selectedHarnessId = '';
        this.contextMenu = '';
        this.lastAnswer = null;
        this.pendingRequest = null;
        this.message = '';
        this.errorMessage = '';
        this.confirmDeleteConversationId = '';
        this.resetContextSelectionsDom();
        await this.renderView();
        requestAnimationFrame(() => {
            this.resetContextSelectionsDom();
            const composer = document.querySelector('.qa-composer textarea') as HTMLTextAreaElement;
            composer?.focus();
        });
    }

    public async selectConversation(conversationId: string) {
        if (!conversationId || this.asking) return;
        this.activeConversationId = conversationId;
        this.lastAnswer = null;
        this.pendingRequest = null;
        this.errorMessage = '';
        this.confirmDeleteConversationId = '';
        await this.renderView();
        this.scrollConversationToBottom();
    }

    public async requestConversationDelete(event: Event, conversationId: string) {
        event.preventDefault();
        event.stopPropagation();
        if (!conversationId || this.deletingConversationId) return;
        if (this.asking && conversationId === this.activeConversationId) {
            this.errorMessage = '답변을 작성 중인 대화는 완료된 뒤 삭제할 수 있습니다.';
            await this.renderView();
            return;
        }
        this.confirmDeleteConversationId = conversationId;
        await this.renderView();
    }

    public async cancelConversationDelete() {
        this.confirmDeleteConversationId = '';
        await this.renderView();
    }

    public async deleteConversation(event: Event, conversationId: string) {
        event.preventDefault();
        event.stopPropagation();
        if (!conversationId || this.deletingConversationId) return;
        const previousActivity = [...(this.overview.activity || [])];
        const previousQueuedRequests = [...this.queuedRequests];
        const previousConversationId = this.activeConversationId;
        const previousLastAnswer = this.lastAnswer;
        const wasAlreadyDeleted = this.deletedConversationIds.has(conversationId);
        this.deletingConversationId = conversationId;
        this.deletedConversationIds.add(conversationId);
        this.errorMessage = '';
        this.confirmDeleteConversationId = '';
        this.overview.activity = previousActivity.filter(
            (item: any) => this.conversationId(item) !== conversationId
        );
        this.queuedRequests = this.queuedRequests.filter(
            (item: any) => item.conversation_id !== conversationId
        );
        if (this.lastAnswer && this.conversationId(this.lastAnswer) === conversationId) {
            this.lastAnswer = null;
        }
        if (this.activeConversationId === conversationId) {
            this.activeConversationId = '';
            this.pendingRequest = null;
            this.ensureActiveConversation();
        }
        await this.renderView();
        try {
            const result = await this.post({ action: 'delete_conversation', conversation_id: conversationId });
            if (Number(result?.deleted_count || 0) < 1) {
                throw new Error('삭제할 채팅 기록을 찾지 못했습니다. 대화 목록을 새로고침해주세요.');
            }
            if (result?.overview) {
                this.overview = result.overview;
                this.ensureOverviewShape();
            } else {
                await this.loadOverview();
            }
        } catch (error: any) {
            if (!wasAlreadyDeleted) this.deletedConversationIds.delete(conversationId);
            this.overview.activity = previousActivity;
            this.queuedRequests = previousQueuedRequests;
            this.activeConversationId = previousConversationId;
            this.lastAnswer = previousLastAnswer;
            this.errorMessage = error?.message || '채팅 이력을 삭제하지 못했습니다.';
        } finally {
            this.deletingConversationId = '';
            await this.renderView();
        }
    }

    public startConversationRename(event: Event, chat: any) {
        event.preventDefault();
        event.stopPropagation();
        if (!chat?.id || this.renamingConversationId) return;
        if (this.editingConversationId && this.editingConversationId !== chat.id) {
            this.syncConversationRenameDom(this.editingConversationId, false);
        }
        this.editingConversationId = chat.id;
        this.syncConversationRenameDom(chat.id, true);
        requestAnimationFrame(() => {
            const input = this.conversationRenameInput(chat.id);
            if (input) input.value = String(chat.title || '');
            input?.focus();
            input?.setSelectionRange(input.value.length, input.value.length);
        });
    }

    public cancelConversationRename(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        const conversationId = this.editingConversationId;
        this.editingConversationId = '';
        this.syncConversationRenameDom(conversationId, false);
    }

    public async saveConversationRename(event: Event, conversationId: string) {
        event.preventDefault();
        event.stopPropagation();
        const input = this.conversationRenameInput(conversationId);
        const title = String(input?.value || '').trim();
        if (!conversationId || title.length < 2 || this.renamingConversationId) return;
        const previousActivity = this.overview.activity || [];
        this.renamingConversationId = conversationId;
        this.editingConversationId = '';
        this.overview.activity = previousActivity.map((item: any) => (
            this.conversationId(item) === conversationId ? { ...item, conversation_title: title } : item
        ));
        this.syncConversationRenameDom(conversationId, false);
        this.syncConversationTitleDom(conversationId, title);
        try {
            const result = await this.post({ action: 'rename_conversation', conversation_id: conversationId, title });
            this.overview = result?.overview || this.overview;
            this.ensureOverviewShape();
        } catch (error: any) {
            this.overview.activity = previousActivity;
            this.errorMessage = error?.message || '채팅 제목을 변경하지 못했습니다.';
        } finally {
            this.renamingConversationId = '';
            await this.renderView();
        }
    }

    public onConversationRenameKeydown(event: KeyboardEvent, conversationId: string) {
        if (event.key === 'Escape') {
            event.preventDefault();
            this.cancelConversationRename(event);
        } else if (event.key === 'Enter') {
            event.preventDefault();
            void this.saveConversationRename(event, conversationId);
        }
    }

    public async uploadAttachment(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        input.value = '';
        if (!file || this.uploadingFile || this.attachments.length >= 5) return;
        this.uploadingFile = true;
        this.errorMessage = '';
        await this.renderView();
        try {
            const body = new FormData();
            body.set('file', file);
            const response = await fetch('/api/v1/review-workspace/operator-file', {
                method: 'POST', credentials: 'same-origin', cache: 'no-store',
                headers: { Accept: 'application/json' }, body
            });
            const payload = await this.readPayload(response);
            const requestError = this.responseError(response, payload, '파일을 업로드하지 못했습니다.');
            if (requestError) throw requestError;
            this.attachments.push(this.unwrap(payload));
        } catch (error: any) {
            this.errorMessage = error?.message || '파일을 업로드하지 못했습니다.';
        } finally {
            this.uploadingFile = false;
            await this.renderView();
        }
    }

    public async removeAttachment(attachmentId: string) {
        this.attachments = this.attachments.filter((item: any) => item.id !== attachmentId);
        await this.renderView();
    }

    public async ask(event?: Event) {
        event?.preventDefault();
        const value = this.message.trim();
        if (!value) return;
        const request = this.createQueuedRequest(value);
        this.message = '';
        this.attachments = [];
        if (this.asking) {
            request.from_queue = true;
            this.queuedRequests.push(request);
            this.syncAskDom(true);
            await this.renderView();
            this.scrollQueueToBottom();
            return;
        }
        await this.executeRequest(request);
    }

    public modelOptions(): any[] {
        const options = this.overview?.runtime?.available_models;
        return Array.isArray(options) ? options : [];
    }

    public modelChoiceLabel(): string {
        const selected = this.modelOptions().find((item: any) => item.id === this.selectedModel);
        return selected?.label || this.overview?.runtime?.model || '기본 모델';
    }

    public async toggleModelMenu() {
        this.modelMenuOpen = !this.modelMenuOpen;
        await this.renderView();
    }

    public async chooseModel(model: string) {
        if (model && !this.modelOptions().some((item: any) => item.id === model)) return;
        this.selectedModel = model;
        this.modelMenuOpen = false;
        try { window.localStorage.setItem('reviewops:selected-model', model); } catch (error) { /* storage is optional */ }
        window.dispatchEvent(new Event('reviewops:model-selection-changed'));
        await this.renderView();
    }

    private storedModel(): string {
        try { return window.localStorage.getItem('reviewops:selected-model') || ''; } catch (error) { return ''; }
    }

    public async stopGeneration(edit: boolean = false) {
        if (!this.asking || this.stopping) return;
        this.stopping = true;
        this.stopRequested = true;
        this.stopForEdit = edit;
        if (edit) this.message = String(this.activeRequest?.message || this.pendingRequest?.request || '');
        this.activeStreamController?.abort();
        await this.renderView();
    }

    private async executeRequest(request: any) {
        const value = String(request?.message || '').trim();
        if (!value || this.asking) return;
        let completed = false;
        this.asking = true;
        this.stopping = false;
        this.stopRequested = false;
        this.stopForEdit = false;
        this.activeRequest = request;
        this.activeStreamController = new AbortController();
        this.errorMessage = '';
        this.activeConversationId = request.conversation_id || this.activeConversationId;
        this.selectedProjectId = request.project_id ?? this.selectedProjectId;
        this.selectedSurveyId = request.survey_id ?? this.selectedSurveyId;
        this.selectedHarnessId = request.harness_id ?? this.selectedHarnessId;
        this.pendingRequest = {
            request: value,
            request_type: request.request_type,
            conversation_id: request.conversation_id,
            request_context: request.request_context || [],
            created_at: new Date().toISOString(),
            actor: { name: 'QA 담당자' },
            answer: ''
        };
        this.syncAskDom(true);
        await this.renderView();
        this.scrollConversationToBottom();
        try {
            const payload = {
                action: 'ask',
                message: value,
                ...(request.model ? { model: request.model } : {}),
                project_id: request.project_id,
                survey_id: request.survey_id,
                harness_id: request.harness_id,
                request_type: request.request_type,
                conversation_id: request.conversation_id,
                attachment_ids: (request.attachments || []).map((item: any) => item.id)
            };
            const result = this.isImmediateWorkspaceCommand(value)
                ? await this.post(payload, this.activeStreamController.signal)
                : await this.postStream(payload, async (streamEvent: any) => {
                    if (streamEvent?.type !== 'answer.delta' || typeof streamEvent.delta !== 'string') return;
                    if (!this.pendingRequest || this.stopRequested) return;
                    this.pendingRequest.answer += streamEvent.delta;
                    this.scheduleStreamingDomUpdate();
                }, this.activeStreamController.signal);
            if (!result?.answer || typeof result.answer !== 'string') {
                throw new Error('운영 도우미가 답변을 반환하지 않았습니다. 잠시 후 다시 시도해주세요.');
            }
            this.lastAnswer = {
                ...result,
                request: result?.request || value,
                created_at: result?.created_at || new Date().toISOString(),
                actor: { name: 'QA 담당자' },
                type: 'assistant.response'
            };
            this.activeConversationId = result?.conversation_id || this.activeConversationId;
            if (result?.proposal?.status === 'pending' && result?.proposal?.kind !== 'project_creation') {
                this.approvalDrawerOpen = true;
            }
            this.pendingRequest = null;
            completed = true;
            await this.renderView();
            this.scrollConversationToBottom();
            await this.loadOverview();
        } catch (error: any) {
            if (this.stopRequested || error?.name === 'AbortError') {
                const keepStoppedExchange = !this.stopForEdit;
                try {
                    const result = await this.post({
                        action: 'cancel_request',
                        conversation_id: request.conversation_id,
                        partial_answer: String(this.pendingRequest?.answer || '').slice(0, 6000),
                        retain: keepStoppedExchange
                    });
                    if (result?.overview) {
                        this.overview = result.overview;
                        this.ensureOverviewShape();
                    }
                } catch (cancelError: any) {
                    this.errorMessage = cancelError?.message || '요청 중지 상태를 저장하지 못했습니다.';
                }
                if (this.stopForEdit) this.message = value;
            } else {
                this.errorMessage = error?.message || '요청을 처리하지 못했습니다.';
                if (request.from_queue) {
                    request.failed = true;
                    this.queuedRequests.unshift(request);
                } else {
                    if (!this.message.trim()) this.message = value;
                    if (!this.attachments.length) {
                        this.attachments = (request.attachments || []).map((item: any) => ({ ...item }));
                    }
                }
            }
        } finally {
            this.pendingRequest = null;
            this.asking = false;
            const focusEditor = this.stopRequested && this.stopForEdit;
            this.stopping = false;
            this.stopRequested = false;
            this.stopForEdit = false;
            this.activeRequest = null;
            this.activeStreamController = null;
            this.syncAskDom(false);
            await this.renderView();
            if (focusEditor) this.focusComposerAtEnd();
            if (completed) await this.processNextQueuedRequest();
        }
    }

    public async prioritizeQueuedRequest(item: any) {
        const index = this.queuedRequests.findIndex((entry: any) => entry.id === item?.id);
        if (index < 0) return;
        const [selected] = this.queuedRequests.splice(index, 1);
        selected.failed = false;
        this.queuedRequests.unshift(selected);
        await this.renderView();
        if (!this.asking) await this.processNextQueuedRequest();
    }

    public async deleteQueuedRequest(itemId: string) {
        this.queuedRequests = this.queuedRequests.filter((item: any) => item.id !== itemId);
        if (this.editingQueueId === itemId) {
            this.editingQueueId = '';
            this.queueEditMessage = '';
        }
        await this.renderView();
        if (!this.asking) await this.processNextQueuedRequest();
    }

    public async startQueueEdit(item: any) {
        this.editingQueueId = item?.id || '';
        this.queueEditMessage = String(item?.message || '');
        await this.renderView();
        requestAnimationFrame(() => {
            const editor = document.querySelector('.qa-queue-item__editor textarea') as HTMLTextAreaElement;
            editor?.focus();
            editor?.setSelectionRange(editor.value.length, editor.value.length);
        });
    }

    public async saveQueueEdit() {
        const value = this.queueEditMessage.trim();
        if (!value || !this.editingQueueId) return;
        const item = this.queuedRequests.find((entry: any) => entry.id === this.editingQueueId);
        if (item) {
            item.message = value;
            item.failed = false;
        }
        this.editingQueueId = '';
        this.queueEditMessage = '';
        await this.renderView();
        if (!this.asking) await this.processNextQueuedRequest();
    }

    public async cancelQueueEdit() {
        this.editingQueueId = '';
        this.queueEditMessage = '';
        await this.renderView();
        if (!this.asking) await this.processNextQueuedRequest();
    }

    public onQueueEditKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.cancelQueueEdit();
            return;
        }
        if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
            event.preventDefault();
            void this.saveQueueEdit();
        }
    }

    public onQueueHandlePointerDown(event: PointerEvent, itemId: string) {
        if (event.button !== 0) return;
        this.resetQueuePointer();
        this.queuePointerId = event.pointerId;
        this.queuePointerStart = { x: event.clientX, y: event.clientY };
        this.queueHandle = event.currentTarget as HTMLElement;
        this.queueHandle.setPointerCapture?.(event.pointerId);
        this.queueHoldTimer = window.setTimeout(() => {
            this.draggingQueueId = itemId;
            this.queueHandle?.classList.add('is-active');
            this.queueHandle?.closest('.qa-queue-item')?.classList.add('is-dragging');
        }, 180);
    }

    public onQueueHandlePointerMove(event: PointerEvent) {
        if (event.pointerId !== this.queuePointerId) return;
        if (!this.draggingQueueId && this.queuePointerStart) {
            const distance = Math.hypot(
                event.clientX - this.queuePointerStart.x,
                event.clientY - this.queuePointerStart.y
            );
            if (distance > 8) this.clearQueueHoldTimer();
            return;
        }
        if (!this.draggingQueueId) return;
        event.preventDefault();
        const target = document.elementFromPoint(event.clientX, event.clientY)?.closest('.qa-queue-item') as HTMLElement;
        const targetId = target?.dataset.queueId || '';
        this.clearQueueDropTarget();
        if (!targetId || targetId === this.draggingQueueId) return;
        const bounds = target.getBoundingClientRect();
        this.queueDropTargetId = targetId;
        this.queueDropAfter = event.clientY > bounds.top + bounds.height / 2;
        target.classList.add(this.queueDropAfter ? 'is-drop-after' : 'is-drop-before');
    }

    public onQueueHandlePointerUp(event: PointerEvent) {
        if (event.pointerId !== this.queuePointerId) return;
        const sourceId = this.draggingQueueId;
        const targetId = this.queueDropTargetId;
        const placeAfter = this.queueDropAfter;
        this.resetQueuePointer();
        if (sourceId && targetId) void this.reorderQueuedRequest(sourceId, targetId, placeAfter);
    }

    public onQueueHandleKeydown(event: KeyboardEvent, itemId: string) {
        if (!['ArrowUp', 'ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        const currentIndex = this.queuedRequests.findIndex((item: any) => item.id === itemId);
        const targetIndex = event.key === 'ArrowUp' ? currentIndex - 1 : currentIndex + 1;
        if (currentIndex < 0 || targetIndex < 0 || targetIndex >= this.queuedRequests.length) return;
        const target = this.queuedRequests[targetIndex];
        void this.reorderQueuedRequest(itemId, target.id, event.key === 'ArrowDown');
    }

    public async proposalAction(action: 'apply' | 'rollback' | 'dismiss', proposal: any) {
        if (!proposal?.id || this.actionId) return;
        this.actionId = proposal.id + ':' + action;
        this.errorMessage = '';
        this.clearErrorDom();
        this.syncProposalActionDom(proposal.id, action, true);
        try {
            const result = await this.post({ action, proposal_id: proposal.id });
            const nextUrl = action === 'apply' ? String(result?.proposal?.next_url || '') : '';
            if (result?.overview) {
                this.overview = result.overview;
                this.ensureOverviewShape();
            } else {
                await this.loadOverview();
            }
            this.approvalDrawerOpen = false;
            this.syncApprovalDrawerDom();
            if (nextUrl.startsWith('/review-projects/')) window.location.assign(nextUrl);
        } catch (error: any) {
            this.errorMessage = error?.message || '변경안을 처리하지 못했습니다.';
        } finally {
            this.actionId = '';
            this.syncProposalActionDom(proposal.id, action, false);
            await this.renderView();
        }
    }

    public onComposerKeydown(event: KeyboardEvent) {
        if (event.key !== 'Enter' || event.shiftKey) return;
        if (event.isComposing || event.keyCode === 229) return;
        event.preventDefault();
        this.ask();
    }

    public onComposerInput(event: Event) {
        const input = event.target as HTMLTextAreaElement;
        input.style.height = '36px';
        input.style.height = `${Math.min(Math.max(input.scrollHeight, 36), 140)}px`;
        input.style.overflowY = input.scrollHeight > 140 ? 'auto' : 'hidden';
        const button = document.querySelector('.qa-send-button') as HTMLButtonElement;
        if (button) button.disabled = !String(input?.value || '').trim();
    }

    public conversations() {
        const activity = [...(this.overview.activity || [])]
            .filter((item: any) => (
                ['assistant.response', 'assistant.cancelled'].includes(item?.type)
                && !this.deletedConversationIds.has(this.conversationId(item))
                && this.conversationId(item) === this.activeConversationId
            ));
        if (
            this.lastAnswer?.answer
            && !this.deletedConversationIds.has(this.conversationId(this.lastAnswer))
            && this.conversationId(this.lastAnswer) === this.activeConversationId
            && !activity.some((item: any) => item?.id === this.lastAnswer?.activity_id)
        ) {
            activity.unshift({ ...this.lastAnswer, id: this.lastAnswer.activity_id });
        }
        return activity
            .slice(0, 20)
            .reverse();
    }

    public chatHistory() {
        const sessions = new Map<string, any>();
        for (const item of (this.overview.activity || [])) {
            if (!['assistant.response', 'assistant.cancelled'].includes(item?.type)) continue;
            const id = this.conversationId(item);
            if (this.deletedConversationIds.has(id)) continue;
            const projectId = this.activityProjectId(item);
            const projectScoped = Boolean(projectId && String(item?.page_context || '').trim());
            const current = sessions.get(id);
            if (!current) {
                sessions.set(id, {
                    id,
                    title: String(item.conversation_title || item.request || '새 대화'),
                    updated_at: item.completed_at || item.created_at,
                    projectId: projectScoped ? projectId : '',
                    projectName: projectScoped ? this.projectName(projectId) : '',
                    projectScoped
                });
            } else {
                current.title = String(item.conversation_title || current.title);
                if (!current.projectScoped && projectScoped) {
                    current.projectId = projectId;
                    current.projectName = this.projectName(projectId);
                    current.projectScoped = true;
                }
            }
        }
        return Array.from(sessions.values())
            .sort((left: any, right: any) => (
                new Date(right.updated_at || 0).getTime() - new Date(left.updated_at || 0).getTime()
            ));
    }

    public filteredChatHistory() {
        const query = this.historySearch.trim().toLocaleLowerCase('ko');
        if (!query) return this.chatHistory();
        return this.chatHistory().filter((item: any) => (
            String(item.title || '').toLocaleLowerCase('ko').includes(query)
            || String(item.projectName || '').toLocaleLowerCase('ko').includes(query)
        ));
    }

    public directChatHistory() {
        return this.filteredChatHistory().filter((item: any) => !item.projectScoped);
    }

    public projectChatGroups() {
        const groups = new Map<string, any>();
        for (const chat of this.filteredChatHistory().filter((item: any) => item.projectScoped)) {
            const projectId = String(chat.projectId || '');
            if (!projectId) continue;
            if (!groups.has(projectId)) {
                groups.set(projectId, {
                    id: projectId,
                    name: chat.projectName || this.projectName(projectId),
                    updated_at: chat.updated_at,
                    chats: []
                });
            }
            groups.get(projectId).chats.push(chat);
        }
        return Array.from(groups.values()).sort((left: any, right: any) => (
            new Date(right.updated_at || 0).getTime() - new Date(left.updated_at || 0).getTime()
        ));
    }

    public visibleProjectChats(group: any) {
        const projectId = String(group?.id || '');
        const visibleCount = this.projectHistoryVisibleCounts[projectId] || this.projectHistoryPageSize;
        return (Array.isArray(group?.chats) ? group.chats : []).slice(0, visibleCount);
    }

    public hiddenProjectChatCount(group: any) {
        const total = Array.isArray(group?.chats) ? group.chats.length : 0;
        return Math.max(0, total - this.visibleProjectChats(group).length);
    }

    public projectHistoryExpanded(projectId: string) {
        return this.expandedHistoryProjectIds.has(projectId);
    }

    public async toggleProjectHistory(projectId: string) {
        if (!projectId) return;
        if (this.expandedHistoryProjectIds.has(projectId)) {
            this.expandedHistoryProjectIds.delete(projectId);
        } else {
            this.expandedHistoryProjectIds.add(projectId);
        }
        await this.renderView();
    }

    public async toggleHistorySection(section: 'projects' | 'direct') {
        if (section === 'projects') this.projectHistorySectionExpanded = !this.projectHistorySectionExpanded;
        else this.directHistorySectionExpanded = !this.directHistorySectionExpanded;
        await this.renderView();
    }

    public async showMoreProjectHistory(event: Event, group: any) {
        event.preventDefault();
        event.stopPropagation();
        const projectId = String(group?.id || '');
        if (!projectId) return;
        const current = this.projectHistoryVisibleCounts[projectId] || this.projectHistoryPageSize;
        this.projectHistoryVisibleCounts[projectId] = current + this.projectHistoryPageSize;
        await this.renderView();
    }

    public trackConversation(_index: number, item: any) {
        return item?.id;
    }

    public trackProjectHistory(_index: number, item: any) {
        return item?.id;
    }

    public activeConversationTitle() {
        return this.chatHistory().find((item: any) => item.id === this.activeConversationId)?.title || '새 대화';
    }

    public proposalForConversation(item: any) {
        const proposalId = item?.proposal_id || item?.proposal?.id;
        if (!proposalId) return null;
        return (this.overview.proposals || []).find((proposal: any) => proposal?.id === proposalId)
            || item?.proposal
            || null;
    }

    public pendingProposals() {
        return (this.overview.proposals || []).filter((item: any) => (
            item?.status === 'pending' && item?.kind !== 'project_creation'
        ));
    }

    public openDirectAction(item: any) {
        const nextUrl = String(item?.direct_action?.next_url || '');
        if (
            ['/surveys', '/harnesses'].includes(nextUrl)
            || nextUrl.startsWith('/review-projects/')
            || nextUrl.startsWith('/api/v1/review-workspace/operator-file/')
        ) {
            window.location.assign(nextUrl);
        }
    }

    public conversationJobs() {
        const proposalIds = new Set(this.conversations().map((item: any) => item?.proposal_id).filter(Boolean));
        return (this.overview.jobs || []).filter((job: any) => proposalIds.has(job?.proposal_id)).slice(0, 5);
    }

    public generationProgressPercent(job: any) {
        const progress = job?.progress || {};
        const generated = Number(progress.generated_count || job?.qa_count || 0);
        const target = Number(progress.target_qa_count || generated || 0);
        if (!target) return job?.status === 'completed' ? 100 : 4;
        return Math.min(100, Math.max(4, Math.round(generated / target * 100)));
    }

    public generationStatusLabel(status: string) {
        const labels: any = {
            starting: '시작 중', running: '생성 중', cancel_requested: '취소 중',
            cancelled: '취소됨', completed: '완료', failed: '실패'
        };
        return labels[status] || status;
    }

    public async generationAction(action: 'cancel_generation' | 'retry_generation', job: any) {
        if (!job?.id || this.generationActionId) return;
        this.generationActionId = job.id + ':' + action;
        try {
            const result = await this.post({ action, job_id: job.id });
            this.overview = result?.overview || this.overview;
            this.ensureOverviewShape();
        } catch (error: any) {
            this.errorMessage = error?.message || 'QA 생성 작업을 처리하지 못했습니다.';
        } finally {
            this.generationActionId = '';
            await this.renderView();
        }
    }

    public appliedProposals() {
        return (this.overview.proposals || [])
            .filter((item: any) => [
                'starting', 'running', 'cancel_requested', 'cancelled',
                'completed', 'failed', 'applied', 'approved', 'queued'
            ].includes(item?.status))
            .slice(0, 5);
    }

    public projectName(projectId: string) {
        return this.overview.projects.find((item: any) => item.id === projectId)?.name || projectId;
    }

    public harnessName(harnessId: string) {
        return this.overview.harnesses.find((item: any) => item.id === harnessId)?.name || harnessId;
    }

    public surveyName(surveyId: string) {
        return this.overview.surveys.find((item: any) => item.id === surveyId)?.name || surveyId;
    }

    public proposalTarget(item: any) {
        if (item?.kind === 'project_creation') return item.project_name || '새 프로젝트';
        if (item?.kind === 'project_deletion') return item.project_name || item.target_id || '삭제할 프로젝트';
        if (item?.kind === 'harness_rules') return this.harnessName(item.target_id);
        if (item?.kind === 'development_request' && !item?.target_id) return '공통 운영 기능';
        return this.projectName(item?.target_id);
    }

    public proposalKind(item: any) {
        const labels: any = {
            project_creation: '프로젝트 생성',
            project_deletion: '프로젝트 삭제',
            survey_creation: '설문지 생성',
            harness_creation: '하네스 생성',
            qa_generation: 'QA 실행',
            project_qa_settings: 'Q&A 생성 설정',
            harness_rules: '하네스 규칙',
            development_request: '개발 수정 요청'
        };
        return labels[item?.kind] || '운영 요청';
    }

    public proposalActionLabel(item: any) {
        if (item?.kind === 'project_creation') return '프로젝트 생성';
        if (item?.kind === 'project_deletion') return '프로젝트 삭제';
        if (item?.kind === 'survey_creation') return '설문지 생성';
        if (item?.kind === 'harness_creation') return '하네스 생성';
        // 기존 "생성 화면 열기" 이동 대신 운영 도우미에서 바로 실행합니다.
        if (item?.kind === 'qa_generation') return 'QA 생성 시작';
        if (item?.kind === 'development_request') return '개발 요청 등록';
        return 'QA에 적용';
    }

    public proposalActionIcon(item: any) {
        return item?.kind === 'project_deletion' ? 'fa-trash-can' : 'fa-check';
    }

    public requestTypeLabel(requestType: string) {
        const labels: any = {
            auto: '자동 분석', lookup: '조회', execute: '실행', change: '변경안', development: '문제 개선'
        };
        return labels[requestType] || '자동 분석';
    }

    public composerPlaceholder() {
        return '필요한 작업이나 궁금한 내용을 입력하세요';
    }

    public composerActionLabel() {
        return this.asking ? '작업 큐에 추가' : '요청 보내기';
    }

    public queuedRequestScope(item: any) {
        const scopes = [
            item?.project_id ? this.projectName(item.project_id) : '',
            item?.survey_id ? this.surveyName(item.survey_id) : '',
            item?.harness_id ? this.harnessName(item.harness_id) : ''
        ].filter(Boolean);
        return scopes.length ? scopes.join(' · ') : '전체 범위';
    }

    public proposalCompletedAt(item: any) {
        return item?.completed_at || item?.applied_at || item?.approved_at || item?.queued_at || item?.created_at;
    }

    public statusLabel(status: string) {
        const labels: any = {
            pending: '승인 대기', starting: '시작 중', running: '생성 중', failed: '실패',
            cancelled: '취소됨', completed: '처리 완료', applied: 'QA 적용됨', approved: '실행 승인',
            queued: '개발 대기', rolled_back: '되돌림', dismissed: '반려'
        };
        return labels[status] || status;
    }

    public severityLabel(severity: string) {
        return severity === 'critical' ? '긴급' : severity === 'warning' ? '주의' : '안내';
    }

    public fieldLabel(field: string) {
        const labels: any = {
            targetQaCount: '생성 수량', target: '통과 기준', maxRounds: '최대 검수 회차',
            primarySourceRatio: '1차 사료 비율', neutralQuestionRatio: '중립 질문 비율',
            usageMode: '활용 방식', outOfScopePolicy: '범위 밖 응답',
            adversarialPolicy: '반박 질문 처리', languagePolicy: '언어 처리',
            name: '프로젝트 이름', action: '실행 작업', target_qa_count: '이번 생성 수량',
            area: '수정 영역', priority: '우선순위'
        };
        return labels[field] || field;
    }

    public valueLabel(value: any) {
        const labels: any = {
            generate_qa: 'QA 생성', regenerate_qa: 'QA 재생성',
            normal: '보통', high: '높음', critical: '긴급'
        };
        return labels[value] || value;
    }

    public answerHtml(value: any) {
        const escaped = String(value ?? '').replace(/[&<>"']/g, (character: string) => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        } as any)[character]);
        return escaped
            .replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>')
            .replace(/`([^`\n]+)`/g, '<code>$1</code>')
            .replace(/\n/g, '<br>');
    }

    public messageCopyKey(item: any, role: 'request' | 'answer') {
        const messageId = item?.id || item?.activity_id || item?.created_at || item?.request || 'message';
        return `${this.conversationId(item)}:${messageId}:${role}`;
    }

    public isMessageCopied(item: any, role: 'request' | 'answer') {
        return this.copiedMessageKey === this.messageCopyKey(item, role);
    }

    public async copyMessage(item: any, role: 'request' | 'answer') {
        const value = String(role === 'request' ? item?.request : item?.answer || '').trim();
        if (!value) return;
        try {
            await this.writeClipboard(value);
            this.copiedMessageKey = this.messageCopyKey(item, role);
            if (this.copyResetTimer !== null) window.clearTimeout(this.copyResetTimer);
            this.copyResetTimer = window.setTimeout(() => {
                this.copiedMessageKey = '';
                this.copyResetTimer = null;
                void this.renderView();
            }, 1600);
            await this.renderView();
        } catch (error) {
            this.errorMessage = '메시지를 복사하지 못했습니다. 다시 시도해주세요.';
            await this.renderView();
        }
    }

    public formatMessageTime(value: string) {
        if (!value) return '시간 정보 없음';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return new Intl.DateTimeFormat('ko-KR', {
            hour: 'numeric', minute: '2-digit'
        }).format(date);
    }

    public formatMessageTimestamp(value: string) {
        if (!value) return '전송 시각 정보 없음';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit'
        }).format(date);
    }

    public formatDate(value: string) {
        if (!value) return '—';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return new Intl.DateTimeFormat('ko-KR', {
            month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
        }).format(date);
    }

    private async writeClipboard(value: string) {
        if (navigator.clipboard?.writeText && window.isSecureContext) {
            await navigator.clipboard.writeText(value);
            return;
        }
        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        textarea.style.pointerEvents = 'none';
        document.body.appendChild(textarea);
        textarea.select();
        const copied = document.execCommand('copy');
        textarea.remove();
        if (!copied) throw new Error('clipboard-copy-failed');
    }

    public actionBusy(proposal: any, action: string) {
        return this.actionId === proposal?.id + ':' + action;
    }

    public environmentLabel() {
        const environment = String(this.overview.runtime?.environment || '').toLowerCase();
        const labels: any = { development: '개발', dev: '개발', qa: 'QA', staging: 'QA', production: '운영', prod: '운영' };
        return labels[environment] || environment.toUpperCase() || '환경 확인 중';
    }

    public credentialLabel() {
        const scope = this.overview.runtime?.credential_scope;
        if (scope === 'codex_device') return 'Codex 디바이스 인증';
        if (scope === 'dedicated') return '전용 API 키';
        if (scope === 'shared') return '공용 API 키';
        return scope === 'injected' ? '주입형 API 키' : 'API 키 확인 중';
    }

    public codexLoginLabel() {
        if (this.codexAuthLoading) return '확인 중';
        if (this.codexAuth.connected) return 'Codex 연결됨';
        return this.codexAuthPending() ? '인증 대기 중' : 'Codex 로그인';
    }

    public codexAuthPending() {
        return ['starting', 'pending'].includes(String(this.codexAuth.state || ''));
    }

    public codexMinutesRemaining() {
        return Math.max(0, Math.ceil(Number(this.codexAuth.remaining_seconds || 0) / 60));
    }

    public async codexLogin() {
        if (this.codexAuthLoading) return;
        this.codexAuthDialogOpen = true;
        await this.renderView();
        if (this.codexAuthPending()) {
            this.startCodexAuthPolling();
        } else if (!this.codexAuth.connected) {
            await this.startCodexDeviceAuth(false);
        }
    }

    public async startCodexDeviceAuth(restart: boolean = false) {
        if (this.codexAuthStarting) return;
        this.codexAuthStarting = true;
        this.errorMessage = '';
        try {
            this.codexAuth = await this.requestCodexAuth(restart ? 'restart' : 'start');
            if (this.codexAuthPending()) this.startCodexAuthPolling();
        } catch (error: any) {
            this.codexAuth = {
                ...this.codexAuth,
                connected: false,
                state: 'error',
                message: error?.message || 'Codex 기기 인증을 시작하지 못했습니다.'
            };
            this.stopCodexAuthPolling();
        } finally {
            this.codexAuthStarting = false;
            await this.renderView();
        }
    }

    public async copyCodexCode() {
        try {
            await this.writeClipboard(String(this.codexAuth.user_code || ''));
            this.codexCodeCopied = true;
            if (this.codexCopyResetTimer !== null) window.clearTimeout(this.codexCopyResetTimer);
            this.codexCopyResetTimer = window.setTimeout(() => {
                this.codexCodeCopied = false;
                void this.renderView();
            }, 1600);
            await this.renderView();
        } catch (error) {
            this.errorMessage = '인증 코드를 복사하지 못했습니다.';
            await this.renderView();
        }
    }

    public async confirmCodexAuth() {
        if (this.codexAuthLoading) return;
        await this.loadCodexAuth(true);
        if (this.codexAuthPending()) this.startCodexAuthPolling();
    }

    public async closeCodexAuthDialog() {
        this.codexAuthDialogOpen = false;
        this.stopCodexAuthPolling();
        await this.renderView();
    }

    public async disconnectCodex() {
        if (this.codexDisconnecting) return;
        this.codexDisconnecting = true;
        this.errorMessage = '';
        try {
            this.codexAuth = await this.requestCodexAuth('disconnect');
            this.codexAuthDialogOpen = false;
            this.stopCodexAuthPolling();
        } catch (error: any) {
            this.errorMessage = error?.message || 'Codex 연결을 해제하지 못했습니다.';
        } finally {
            this.codexDisconnecting = false;
            await this.renderView();
        }
    }

    public usagePercent(value: any, limit: any) {
        const current = Number(value || 0);
        const maximum = Number(limit || 0);
        if (!Number.isFinite(current) || !Number.isFinite(maximum) || maximum <= 0) return 0;
        return Math.min(100, Math.max(0, Math.round(current / maximum * 100)));
    }

    public formatNumber(value: any) {
        const number = Number(value || 0);
        return Number.isFinite(number) ? new Intl.NumberFormat('ko-KR').format(number) : '0';
    }

    private scrollConversationToBottom() {
        requestAnimationFrame(() => {
            const element = document.querySelector('.qa-conversation');
            if (element) element.scrollTop = element.scrollHeight;
        });
    }

    private scrollQueueToBottom() {
        requestAnimationFrame(() => {
            const element = document.querySelector('.qa-request-queue__list');
            if (element) element.scrollTop = element.scrollHeight;
        });
    }

    private focusComposerAtEnd() {
        requestAnimationFrame(() => {
            const composer = document.querySelector('.qa-composer textarea') as HTMLTextAreaElement;
            composer?.focus();
            composer?.setSelectionRange(composer.value.length, composer.value.length);
        });
    }

    private createQueuedRequest(message: string) {
        const values = new Uint32Array(2);
        window.crypto.getRandomValues(values);
        return {
            id: `QUEUE-${Date.now().toString(36)}-${values[0].toString(36)}${values[1].toString(36)}`,
            message,
            request_type: this.selectedContextRequestType(),
            model: this.modelOptions().some((item: any) => item.id === this.selectedModel) ? this.selectedModel : '',
            project_id: this.selectedProjectId,
            survey_id: this.selectedSurveyId,
            harness_id: this.selectedHarnessId,
            request_context: this.requestContextSnapshot(),
            conversation_id: this.activeConversationId,
            attachments: this.attachments.map((item: any) => ({ ...item })),
            created_at: new Date().toISOString(),
            from_queue: false,
            failed: false
        };
    }

    private requestContextSnapshot() {
        return [
            {
                kind: 'project', label: '프로젝트', id: this.selectedProjectId,
                name: this.selectedProjectId ? this.projectName(this.selectedProjectId) : '전체 프로젝트',
                selected: !!this.selectedProjectId
            },
            {
                kind: 'survey', label: '설문지', id: this.selectedSurveyId,
                name: this.selectedSurveyId ? this.surveyName(this.selectedSurveyId) : '전체 설문지',
                selected: !!this.selectedSurveyId
            },
            {
                kind: 'harness', label: '하네스', id: this.selectedHarnessId,
                name: this.selectedHarnessId ? this.harnessName(this.selectedHarnessId) : '전체 하네스',
                selected: !!this.selectedHarnessId
            }
        ];
    }

    private selectedContextRequestType() {
        // A selected survey or harness is an explicit resource-operation scope.
        // `execute` still permits lookups and content changes, while preventing
        // ordinary survey wording from being misclassified as a development task.
        return this.selectedSurveyId || this.selectedHarnessId ? 'execute' : 'auto';
    }

    private isImmediateWorkspaceCommand(message: string) {
        const compact = String(message || '').replace(/\s+/g, '');
        const historicalQuestion = ['생성한', '생성된', '생성했던', '만든', '만들어진', '추가한', '추가된']
            .some((word: string) => compact.includes(word))
            && ['뭐', '무엇', '어떤', '어느', '언제', '어떻게', '왜', '알려', '확인', '조회', '?']
                .some((word: string) => compact.includes(word));
        const createsResource = !historicalQuestion && ['프로젝트', '설문지', '하네스'].some((resource: string) => {
            const directAction = new RegExp(
                `(?:새|새로운)?${resource}(?:를|을)?(?:(?:하나|한개|1개)(?:를|을|만)?)?`
                + `(?:새로)?(?:생성해|생성하|만들어|만들자|추가해|추가하)`
            ).test(compact);
            return directAction || [`${resource}생성`, `${resource}만들기`, `${resource}추가`]
                .some((suffix: string) => compact.endsWith(suffix));
        });
        const managesSurvey = compact.includes('설문')
            && ['업로드', '새버전', '활성버전', '문항검증'].some((action: string) => compact.includes(action));
        const createsFile = compact.includes('파일')
            && ['생성', '만들', '다운로드', '내려받'].some((action: string) => compact.includes(action));
        const importsResource = ['하네스', '설문지', '설문'].some((resource: string) => compact.includes(resource))
            && ['업로드', '불러와', '가져와', '적용해', '연결해', '등록해']
                .some((action: string) => compact.includes(action));
        const generatesQa = /(?:QA|큐에이|질문답변)(?:세트|셋)?/i.test(compact)
            && /(?:재생성|다시생성|생성|만들|뽑|실행)(?:(?:[0-9]{1,3}|하나|다섯|여섯|일곱|여덟|아홉|둘|넷|한|두|세|네|열)(?:개|건)(?:만)?)?(?:까지)?(?:해|하|시작|돌려|시켜)/.test(compact);
        return createsResource || managesSurvey || createsFile || importsResource || generatesQa;
    }

    private async processNextQueuedRequest() {
        if (this.asking || this.editingQueueId || !this.queuedRequests.length) return;
        if (this.queuedRequests[0]?.failed) return;
        const next = this.queuedRequests.shift();
        if (!next) return;
        await this.executeRequest(next);
    }

    private async reorderQueuedRequest(sourceId: string, targetId: string, placeAfter: boolean) {
        const sourceIndex = this.queuedRequests.findIndex((item: any) => item.id === sourceId);
        if (sourceIndex < 0 || sourceId === targetId) return;
        const [source] = this.queuedRequests.splice(sourceIndex, 1);
        const targetIndex = this.queuedRequests.findIndex((item: any) => item.id === targetId);
        if (targetIndex < 0) {
            this.queuedRequests.splice(sourceIndex, 0, source);
            return;
        }
        this.queuedRequests.splice(targetIndex + (placeAfter ? 1 : 0), 0, source);
        await this.renderView();
    }

    private clearQueueHoldTimer() {
        if (this.queueHoldTimer !== null) window.clearTimeout(this.queueHoldTimer);
        this.queueHoldTimer = null;
    }

    private clearQueueDropTarget() {
        document.querySelectorAll('.qa-queue-item.is-drop-before, .qa-queue-item.is-drop-after')
            .forEach((element: Element) => element.classList.remove('is-drop-before', 'is-drop-after'));
        this.queueDropTargetId = '';
        this.queueDropAfter = false;
    }

    private resetQueuePointer() {
        this.clearQueueHoldTimer();
        this.clearQueueDropTarget();
        document.querySelectorAll('.qa-queue-item.is-dragging')
            .forEach((element: Element) => element.classList.remove('is-dragging'));
        this.queueHandle?.classList.remove('is-active');
        if (this.queueHandle && this.queuePointerId !== null) {
            this.queueHandle.releasePointerCapture?.(this.queuePointerId);
        }
        this.draggingQueueId = '';
        this.queuePointerId = null;
        this.queuePointerStart = null;
        this.queueHandle = null;
    }

    private async renderView() {
        if (this.renderInFlight) {
            this.renderQueued = true;
            await this.renderInFlight;
            return;
        }
        const render = async () => {
            do {
                this.renderQueued = false;
                await this.service.render();
            } while (this.renderQueued);
        };
        this.renderInFlight = render();
        try {
            await this.renderInFlight;
        } finally {
            this.renderInFlight = null;
        }
    }

    private async loadCodexAuth(silent: boolean = false) {
        if (!silent) this.codexAuthLoading = true;
        try {
            this.codexAuth = await this.requestCodexAuth('status');
        } catch (error: any) {
            this.codexAuth = {
                available: false,
                connected: false,
                state: 'error',
                message: error?.message || 'Codex 로그인 상태를 확인하지 못했습니다.'
            };
        } finally {
            if (!silent) this.codexAuthLoading = false;
            if (!this.codexAuthPending()) this.stopCodexAuthPolling();
            await this.renderView();
        }
    }

    private async requestCodexAuth(action: 'status' | 'start' | 'restart' | 'disconnect') {
        const transportIds: Record<string, string> = {
            status: 'SYS-CODEX-AUTH-STATUS',
            start: 'SYS-CODEX-AUTH-START',
            restart: 'SYS-CODEX-AUTH-RESTART',
            disconnect: 'SYS-CODEX-AUTH-DISCONNECT'
        };
        const result = await this.post({
            action: 'delete_conversation',
            conversation_id: transportIds[action]
        });
        if (!result?.codex_auth || typeof result.codex_auth !== 'object') {
            throw new Error('Codex 로그인 상태 응답이 올바르지 않습니다.');
        }
        return result.codex_auth;
    }

    private startCodexAuthPolling() {
        if (this.codexAuthPollTimer !== null) return;
        this.codexAuthPollTimer = window.setInterval(() => {
            if (!this.codexAuthDialogOpen || !this.codexAuthPending()) {
                this.stopCodexAuthPolling();
                return;
            }
            void this.loadCodexAuth(true);
        }, 2000);
    }

    private stopCodexAuthPolling() {
        if (this.codexAuthPollTimer === null) return;
        window.clearInterval(this.codexAuthPollTimer);
        this.codexAuthPollTimer = null;
    }

    private clearErrorDom() {
        document.querySelector('.qa-operator-alert')?.remove();
    }

    private conversationHistoryEntry(conversationId: string) {
        return Array.from(document.querySelectorAll('.qa-history-entry')).find(
            (entry: Element) => (entry as HTMLElement).dataset.conversationId === conversationId
        ) as HTMLElement | undefined;
    }

    private conversationRenameInput(conversationId: string) {
        return this.conversationHistoryEntry(conversationId)?.querySelector('.qa-history-rename input') as HTMLInputElement | null;
    }

    private syncConversationRenameDom(conversationId: string, editing: boolean) {
        if (!conversationId) return;
        this.conversationHistoryEntry(conversationId)?.classList.toggle('is-renaming', editing);
    }

    private syncConversationTitleDom(conversationId: string, title: string) {
        const titleNode = this.conversationHistoryEntry(conversationId)?.querySelector('.qa-history-item strong');
        if (titleNode) titleNode.textContent = title;
        if (conversationId === this.activeConversationId) {
            const activeTitle = document.querySelector('.qa-chat-title h1');
            if (activeTitle) activeTitle.textContent = title;
        }
    }

    private syncRefreshDom(loading: boolean) {
        const button = document.querySelector('[data-action="refresh-overview"]') as HTMLButtonElement;
        if (!button) return;
        button.disabled = loading;
        button.setAttribute('aria-busy', String(loading));
        const icon = button.querySelector('i');
        if (icon) icon.className = loading ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-rotate';
    }

    private syncApprovalDrawerDom() {
        const open = this.approvalDrawerOpen;
        const toggle = document.querySelector('.qa-approval-toggle') as HTMLButtonElement;
        const backdrop = document.querySelector('.qa-approval-backdrop') as HTMLButtonElement;
        const drawer = document.querySelector('.qa-approval-drawer') as HTMLElement;
        toggle?.classList.toggle('is-active', open);
        toggle?.setAttribute('aria-expanded', String(open));
        backdrop?.classList.toggle('is-open', open);
        backdrop?.setAttribute('aria-hidden', String(!open));
        if (backdrop) backdrop.tabIndex = open ? 0 : -1;
        drawer?.classList.toggle('is-open', open);
        drawer?.setAttribute('aria-hidden', String(!open));
    }

    private syncContextMenuDom() {
        document.querySelectorAll('.qa-context-picker').forEach((node: Element) => {
            const picker = node as HTMLElement;
            const type = picker.dataset.contextPicker || '';
            const open = this.contextMenu === type;
            picker.classList.toggle('is-open', open);
            picker.querySelector('.qa-context-trigger')?.setAttribute('aria-expanded', String(open));
            picker.querySelector('.qa-context-menu')?.setAttribute('aria-hidden', String(!open));
        });
    }

    private resetContextSelectionsDom() {
        const labels: Record<string, string> = {
            project: '전체 프로젝트', survey: '전체 설문지', harness: '전체 하네스'
        };
        for (const type of Object.keys(labels)) {
            const picker = document.querySelector(`[data-context-picker="${type}"]`) as HTMLElement | null;
            if (!picker) continue;
            picker.classList.remove('is-open');
            picker.querySelector('.qa-context-trigger')?.setAttribute('aria-expanded', 'false');
            picker.querySelector('.qa-context-menu')?.setAttribute('aria-hidden', 'true');
            const label = picker.querySelector('.qa-context-trigger span');
            if (label) label.textContent = labels[type];
            const options = Array.from(picker.querySelectorAll('.qa-context-option')) as HTMLElement[];
            options.forEach((option: HTMLElement, index: number) => {
                option.classList.toggle('is-selected', index === 0);
                option.setAttribute('aria-selected', String(index === 0));
            });
        }
    }

    private focusContextOption(type: string) {
        const menu = document.querySelector(`[data-context-menu="${type}"]`);
        const selected = menu?.querySelector('.qa-context-option.is-selected') as HTMLButtonElement;
        const first = menu?.querySelector('.qa-context-option') as HTMLButtonElement;
        (selected || first)?.focus();
    }

    private syncAskDom(asking: boolean) {
        const button = document.querySelector('.qa-send-button') as HTMLButtonElement;
        if (!button) return;
        button.disabled = !this.message.trim();
        button.setAttribute('aria-busy', 'false');
        button.setAttribute('title', asking ? '작업 큐에 추가' : '요청 보내기');
        button.setAttribute('aria-label', asking ? '작업 큐에 추가' : '요청 보내기');
        const icon = button.querySelector('i');
        if (icon) icon.className = 'fa-solid fa-arrow-up';
    }

    private syncProposalActionDom(proposalId: string, action: string, busy: boolean) {
        document.querySelectorAll('button[data-proposal-action]').forEach((node: Element) => {
            const button = node as HTMLButtonElement;
            const container = button.closest('[data-proposal-id]') as HTMLElement;
            const isTarget = container?.dataset.proposalId === proposalId
                && button.dataset.proposalAction === action;
            button.disabled = busy;
            button.setAttribute('aria-busy', String(busy && isTarget));
            const icon = button.querySelector('i');
            if (!icon || !isTarget) return;
            if (busy) {
                icon.className = 'fa-solid fa-spinner fa-spin';
            } else if (action === 'rollback') {
                icon.className = 'fa-solid fa-rotate-left';
            } else if (action === 'dismiss') {
                icon.className = 'fa-solid fa-xmark';
            } else {
                icon.className = 'fa-solid fa-check';
            }
        });
    }

    private scheduleStreamingDomUpdate() {
        if (this.streamFrame !== null) return;
        this.streamFrame = requestAnimationFrame(() => {
            const target = document.querySelector('.qa-answer-copy--streaming span') as HTMLElement;
            if (target && this.pendingRequest) {
                target.innerHTML = this.answerHtml(this.pendingRequest.answer);
                this.scrollConversationToBottom();
                this.streamFrame = null;
                return;
            }
            void this.renderView().then(() => {
                const streamedAnswer = document.querySelector('.qa-answer-copy--streaming span') as HTMLElement;
                if (streamedAnswer && this.pendingRequest) {
                    streamedAnswer.innerHTML = this.answerHtml(this.pendingRequest.answer);
                }
                this.scrollConversationToBottom();
                this.streamFrame = null;
            });
        });
    }

    private async post(payload: any, signal?: AbortSignal) {
        const body = new URLSearchParams();
        body.set('payload', JSON.stringify(payload));
        const response = await fetch(this.endpoint, {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
            body,
            signal
        });
        const responsePayload = await this.readPayload(response);
        const requestError = this.responseError(response, responsePayload, '요청을 처리하지 못했습니다.');
        if (requestError) throw requestError;
        return this.unwrap(responsePayload);
    }

    private async postStream(
        payload: any,
        onEvent: (event: any) => Promise<void>,
        signal?: AbortSignal
    ) {
        const body = new URLSearchParams();
        body.set('payload', JSON.stringify(payload));
        const fallbackToRegularPost = async () => {
            const result = await this.post(payload, signal);
            if (typeof result?.answer === 'string' && result.answer) {
                await onEvent({ type: 'answer.delta', delta: result.answer });
            }
            return result;
        };
        let response: Response;
        try {
            response = await fetch(this.endpoint + '-stream', {
                method: 'POST',
                credentials: 'same-origin',
                cache: 'no-store',
                headers: { Accept: 'application/x-ndjson' },
                body,
                signal
            });
        } catch (error: any) {
            if (signal?.aborted || error?.name === 'AbortError') throw error;
            return fallbackToRegularPost();
        }
        const contentType = String(response.headers.get('Content-Type') || '').toLowerCase();
        if (!response.ok || !contentType.includes('application/x-ndjson')) {
            const responsePayload = await this.readPayload(response);
            const responseCode = String(responsePayload?.code ?? response.status).toUpperCase();
            const responseMessage = String(responsePayload?.message || responsePayload?.data?.message || '');
            const streamRouteMissing = response.status === 404
                || responseCode === '404'
                || responseCode === 'NOT_FOUND'
                || responseMessage.includes('검수 작업공간 API를 찾을 수 없습니다');
            if (streamRouteMissing) {
                return fallbackToRegularPost();
            }
            const requestError = this.responseError(response, responsePayload, '요청을 처리하지 못했습니다.');
            throw requestError || new Error('요청을 처리하지 못했습니다.');
        }
        if (!response.body) return fallbackToRegularPost();

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let result: any = null;
        let streamStarted = false;
        const consumeLine = async (line: string) => {
            if (!line.trim()) return;
            let event: any;
            try {
                event = JSON.parse(line);
            } catch (error) {
                throw new Error('운영 도우미 스트림 형식이 올바르지 않습니다.');
            }
            streamStarted = true;
            if (event?.type === 'error') {
                throw new Error(event.message || '요청을 처리하지 못했습니다.');
            }
            if (event?.type === 'done') result = event.result;
            await onEvent(event);
        };

        try {
            while (true) {
                const chunk = await reader.read();
                buffer += decoder.decode(chunk.value || new Uint8Array(), { stream: !chunk.done });
                const lines = buffer.split('\n');
                buffer = lines.pop() || '';
                for (const line of lines) await consumeLine(line);
                if (chunk.done) break;
            }
            if (buffer.trim()) await consumeLine(buffer);
        } catch (error: any) {
            if (signal?.aborted || error?.name === 'AbortError' || streamStarted) throw error;
            return fallbackToRegularPost();
        }
        if (!result || typeof result !== 'object') {
            throw new Error('운영 도우미가 완료된 답변을 반환하지 않았습니다.');
        }
        return result;
    }

    private responseError(response: Response, payload: any, fallback: string) {
        const code = Number(payload?.code ?? response.status);
        if (response.ok && (!Number.isFinite(code) || code < 400)) return null;
        const message = payload?.message || payload?.data?.message;
        if (message) return new Error(message);
        if (code === 401) return new Error('로그인이 필요합니다. 다시 로그인해주세요.');
        if (code === 403) return new Error('Q&A 운영 도우미를 사용할 관리자 권한이 필요합니다.');
        return new Error(fallback);
    }

    private async readPayload(response: Response) {
        try { return await response.json(); } catch (error) { return null; }
    }

    private unwrap(payload: any) {
        const candidates = [payload?.data?.data, payload?.data, payload?.result, payload];
        return candidates.find((item: any) => item && typeof item === 'object') || {};
    }

    private ensureOverviewShape() {
        for (const key of ['projects', 'surveys', 'harnesses', 'recent_errors', 'proposals', 'activity', 'jobs', 'notifications', 'deleted_conversation_ids']) {
            if (!Array.isArray(this.overview?.[key])) this.overview[key] = [];
        }
        if (!this.overview.runtime || typeof this.overview.runtime !== 'object') this.overview.runtime = {};
        for (const conversationId of this.overview.deleted_conversation_ids) {
            if (typeof conversationId === 'string' && conversationId) {
                this.deletedConversationIds.add(conversationId);
            }
        }
        this.overview.activity = this.overview.activity.filter(
            (item: any) => !this.deletedConversationIds.has(this.conversationId(item))
        );
        if (this.lastAnswer && this.deletedConversationIds.has(this.conversationId(this.lastAnswer))) {
            this.lastAnswer = null;
        }
    }

    private async refreshOverviewSilently() {
        try {
            const response = await fetch(this.endpoint, {
                method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
            });
            const payload = await this.readPayload(response);
            if (!response.ok) return;
            this.overview = this.unwrap(payload);
            this.ensureOverviewShape();
            await this.renderView();
        } catch (error) {
            return;
        }
    }

    private ensureActiveConversation() {
        if (this.activeConversationId) return;
        this.activeConversationId = this.chatHistory()[0]?.id || this.createConversationId();
    }

    private initializeProjectHistory() {
        if (this.projectHistoryInitialized) return;
        const activeChat = this.chatHistory().find((item: any) => (
            item.id === this.activeConversationId && item.projectScoped
        ));
        const activeProjectId = String(activeChat?.projectId || '');
        if (activeProjectId) this.expandedHistoryProjectIds.add(activeProjectId);
        this.projectHistoryInitialized = true;
    }

    private conversationId(item: any) {
        return String(item?.conversation_id || 'CHAT-legacy');
    }

    private activityProjectId(item: any) {
        const requestContext = Array.isArray(item?.request_context) ? item.request_context : [];
        const projectContext = requestContext.find((context: any) => (
            context?.kind === 'project' && context?.selected && context?.id
        ));
        return String(
            projectContext?.id
            || item?.project_id
            || item?.direct_action?.project_id
            || ''
        ).trim();
    }

    private createConversationId() {
        const values = new Uint32Array(2);
        window.crypto.getRandomValues(values);
        return `CHAT-${Date.now().toString(36)}-${values[0].toString(36)}${values[1].toString(36)}`;
    }
}

export default PageQaOperatorComponent;